var YJ_CHECKOUT = (function () {
function norm(s) { return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, " ").trim(); }
var DEPTOS = {
"amazonas": "AMA", "antioquia": "ANT", "arauca": "ARA", "atlantico": "ATL", "bolivar": "BOL", "boyaca": "BOY", "caldas": "CAL",
"caqueta": "CAQ", "casanare": "CAS", "cauca": "CAU", "cesar": "CES", "choco": "CHO", "cordoba": "COR", "cundinamarca": "CUN",
"guainia": "GUA", "guaviare": "GUV", "huila": "HUI", "la guajira": "LAG", "magdalena": "MAG", "meta": "MET", "narino": "NAR",
"norte de santander": "NSA", "putumayo": "PUT", "quindio": "QUI", "risaralda": "RIS", "santander": "SAN", "sucre": "SUC",
"tolima": "TOL", "valle del cauca": "VAC", "vaupes": "VAU", "vichada": "VID",
"san andres y providencia": "SAP", "san andres providencia y santa catalina": "SAP", "archipielago de san andres providencia y santa catalina": "SAP"
};
function provincia(region) {
var n = norm(region).replace(/^(departamento|depto|dpto) (del |de la |de )?/, "");
if (!n) return "";
if (/bogota|distrito capital|^d c$/.test(n)) return "DC";
if (DEPTOS[n]) return DEPTOS[n];
if (n === "valle") return "VAC";
if (n === "guajira") return "LAG";
if (n === "san andres") return "SAP";
return "";
}
function direccion(est) {
est = est || {};
var ciudad = "", prov = "";
if (est.tipo === "bogota") { ciudad = "Bogotá"; prov = "DC"; }
else if (est.tipo === "soacha") { ciudad = "Soacha"; prov = "CUN"; }
else if (est.tipo === "otra") { ciudad = String(est.ciudad || "").trim(); prov = ciudad ? provincia(est.region) : ""; if (/^bogot/.test(norm(ciudad)) || norm(ciudad) === "soacha") ciudad = ""; }
if (!ciudad || ciudad.length > 60 || /[<>\\]|^\d/.test(ciudad)) return null;
var d = { country: "Colombia", city: ciudad };
if (prov) d.province = prov;
return d;
}
function url(raizTienda, est, codigo) {
var u = (raizTienda || "/") + "checkout", d = direccion(est);
var q = [];
if (codigo && /^[A-Za-z0-9_-]{1,40}$/.test(String(codigo))) q.push("discount=" + codigo);
if (!d) return q.length ? u + "?" + q.join("&") : u;
["country", "city", "province"].forEach(function (k) { if (d[k]) q.push("checkout[shipping_address][" + k + "]=" + encodeURIComponent(d[k])); });
return u + "?" + q.join("&");
}
return { url: url, direccion: direccion, provincia: provincia, DEPTOS: DEPTOS };
})();
if (typeof module !== "undefined" && module.exports) module.exports = YJ_CHECKOUT;
(function () {
"use strict";
var raiz = document.querySelector("[data-yj-raiz]");
if (!raiz || raiz.__yj) return;
raiz.__yj = true;
var CFG = window.YJ_CONFIG || {};
var TIENDA = CFG.tienda || {};
var BASE = window.YJ_BASE || "assets/";
var LLEGA_CE = (function () { var t = ((CFG.entrega || {}).tramos || []).filter(function (x) { return x.express; })[0], d = (t && t.dias) || [0, 1]; return d[0] === 0 ? "llega hoy o " + "mañana" : "llega en " + d[0] + " a " + d[1] + " días"; })();
var LOCAL = /^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname);
var DATOS = {};
try { DATOS = JSON.parse(document.getElementById("yj-datos").textContent); } catch (e) { DATOS = {}; }
var VARS = DATOS.variantes || [], FOTOS = DATOS.fotos || [];
var QA = /[?&]qa\b/.test(location.search);
var $ = function (s, r) { return (r || raiz).querySelector(s); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || raiz).querySelectorAll(s)); };
var reducido = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
var comp = reducido ? "auto" : "smooth";
var hayIO = "IntersectionObserver" in window;
var YJ = window.YJ = window.YJ || {};
function leerSes(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
function guardarSes(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
function reanimar(el, c) {
if (!el.classList.contains(c)) { el.classList.add(c); return; }
el.classList.remove(c); requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add(c); }); });
}
function txt(e, s) { var f = e.firstChild; s = String(s); if (s && f && f.nodeType === 3 && !f.nextSibling) { if (f.data !== s) f.data = s; } else if (e.textContent !== s) e.textContent = s; }
function html(e, s) { if (e.__yjH !== s) { e.__yjH = s; e.innerHTML = s; } }
function ocultar(e, si) { si = !!si; if (e.hidden !== si) e.hidden = si; }
function atr(e, k, v) { if (e.getAttribute(k) !== v) e.setAttribute(k, v); }
var cacheQ = {};
function Q(s) { return cacheQ[s] || (cacheQ[s] = $$(s)); }
function olvidar() { cacheQ = {}; }
var pend = {}, pendOrden = [], pendT = 0;
function vaciar() {
clearTimeout(pendT); pendT = 0; var o = pendOrden, p = pend; pendOrden = []; pend = {};
o.forEach(function (k) { try { p[k](); } catch (e) { if (window.console) console.error("yj", e); } });
}
function luego(k, fn) {
if (!pend[k]) pendOrden.push(k); pend[k] = fn;
if (!pendT) { pendT = setTimeout(vaciar, 300); requestAnimationFrame(function () { setTimeout(function () { if (pendT) vaciar(); }, 0); }); }
}
YJ.vaciar = vaciar;
function abrirTras(btn, fn) {
var b = btn && btn.classList ? btn : null; if (b) b.classList.add("is-toque");
luego("abrir", function () { if (b) b.classList.remove("is-toque"); fn(); });
}
var ocio = window.requestIdleCallback ? function (fn) { requestIdleCallback(fn, { timeout: 2500 }); } : function (fn) { setTimeout(fn, 1200); };
function esc(s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;"); }
function norm(s) { return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, " ").trim(); }
function porFrame(fn) { var p = false; return function () { if (p) return; p = true; requestAnimationFrame(function () { p = false; fn(); }); }; }
function ico(n, c) { return '<svg class="yj-i' + (c ? " " + c : "") + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><use href="#yj-g-' + n + '"></use></svg>'; }
function pad(n) { return String(n).padStart(2, "0"); }
YJ.eventos = [];
function track(ev) { YJ.eventos.push(ev); try { if (window.clarity) window.clarity("event", ev); } catch (e) {} }
function marcarDato(k, v) { try { if (window.clarity) window.clarity("set", k, String(v)); } catch (e) {} }
YJ.track = track;
if (CFG.clarityId && !/^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname)) {
window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
var cargarClarity = function () { var s = document.createElement("script"); s.async = true; s.src = "https://www.clarity.ms/tag/" + encodeURIComponent(CFG.clarityId); document.head.appendChild(s); };
var trasLoad = function () { ocio(cargarClarity); };
if (document.readyState === "complete") trasLoad(); else window.addEventListener("load", trasLoad);
marcarDato("pagina", "lipo-jean");
}
var toastT;
function aviso(html, ms) {
var t = $("[data-yj-toast]"); if (!t) return;
t.innerHTML = html; t.classList.add("is-on");
clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove("is-on"); }, ms || 3600);
}
function num(x) { return String(Math.round(x)).replace(/\B(?=(\d{3})+(?!\d))/g, "."); }
function fmt(x) { return "$" + num(x); }
var colores = [], tallas = [], porColor = {};
VARS.forEach(function (v) {
if (colores.indexOf(v.c) < 0) colores.push(v.c);
if (tallas.indexOf(v.t) < 0) tallas.push(v.t);
});
if (tallas.every(function (t) { return !isNaN(+t); })) tallas.sort(function (a, b) { return a - b; });
function cfgColor(c) { var k = norm(c); return (CFG.colores || []).filter(function (x) { return norm(x.nombre) === k; })[0] || null; }
function variante(c, t) { for (var i = 0; i < VARS.length; i++) if (VARS[i].c === c && VARS[i].t === t) return VARS[i]; return null; }
function hayStock(c, t) { var v = variante(c, t); return !!(v && v.d); }
function colorConStock(c) { return tallas.some(function (t) { return hayStock(c, t); }); }
var fotoPorId = {};
FOTOS.forEach(function (f) { fotoPorId[String(f.id)] = f; });
function fotosDe(c) {
if (porColor[c]) return porColor[c];
var x = cfgColor(c), bus = "lipo jean " + norm(c), l = FOTOS.filter(function (f) { return (" " + norm(f.a) + " ").indexOf(" " + bus + " ") > -1; });
if (l.length) { var vis = function (f) { var m = /vista\s+(\d+)/i.exec(f.a || ""); return m ? +m[1] : 1; }; l = l.map(function (f, i) { return { f: f, i: i }; }).sort(function (p, q) { return (vis(p.f) - vis(q.f)) || (p.i - q.i); }).map(function (p) { return p.f; }); }
if (!l.length && x) (x.fotos || []).forEach(function (id) { if (fotoPorId[id]) l.push(fotoPorId[id]); });
if (!l.length) VARS.forEach(function (v) { if (v.c === c && v.f && fotoPorId[String(v.f)] && l.indexOf(fotoPorId[String(v.f)]) < 0) l.push(fotoPorId[String(v.f)]); });
if (!l.length) l = FOTOS.slice();
return (porColor[c] = l);
}
function url(f, w) { return String(f.u).replace(/{w}|YJW/, w); }
var ANCHOS = [360, 540, 720, 1080];
function srcset(f) { return ANCHOS.map(function (w) { return url(f, w) + " " + w + "w"; }).join(", "); }
function alt(f, c) {
if (f.a) return f.a;
var p = (CFG.planos || {})[f.id];
return "Lipo Jean " + c + " de Yass Moda" + (p ? ", " + p : "");
}
function tex(c) { var x = cfgColor(c); if (x) return BASE + "yj-tex-" + x.clave + ".webp"; var f = fotosDe(c)[0]; return f ? url(f, 180) : ""; }
YJ.fotosDe = fotosDe; YJ.url = url;
var P = CFG.precios || { 1: 115000, 2: 195000, 3: 265000 };
var qv = /[?&]variant=(\d+)/.exec(location.search), vIni = null;
if (qv) VARS.forEach(function (v) { if (String(v.id) === qv[1]) vIni = v; });
if (!vIni) { var ssr = raiz.getAttribute("data-yj-variante"); VARS.forEach(function (v) { if (String(v.id) === ssr) vIni = v; }); }
if (!vIni) vIni = VARS.filter(function (v) { return v.d && v.c === CFG.colorInicial; })[0] || VARS.filter(function (v) { return v.d; })[0] || VARS[0] || { c: "", t: "" };
var est = { n: 1, unis: [{ c: vIni.c, t: qv && vIni.d ? vIni.t : null }], regaloTalla: null };
function ajustarUnis() {
while (est.unis.length < est.n) est.unis.push({ c: est.unis[est.unis.length - 1].c, t: null });
est.unis.length = est.n;
}
YJ.estado = est;
var pista = $("[data-yj-gal-pista]"), minis = $("[data-yj-gal-minis]"), galAct = 0;
var SIZES = "(min-width:1240px) 620px, (min-width:900px) 52vw, calc(94vw - 128px)";
function htmlGaleria(c) {
var l = fotosDe(c), s = "", m = "";
l.forEach(function (f, i) {
s += '<figure class="yj-gal__slide" aria-roledescription="diapositiva" aria-label="' + (i + 1) + " de " + l.length + '"><img src="' + esc(url(f, 720)) + '" srcset="' + esc(srcset(f)) + '" sizes="' + SIZES + '" width="' + f.w + '" height="' + f.h + '" alt="' + esc(alt(f, c)) + '"' + (i ? ' loading="lazy"' : ' fetchpriority="high"') + ' decoding="async" draggable="false"></figure>';
m += '<button type="button" class="yj-gal__mini" data-yj-mini="' + i + '" aria-label="Ver foto ' + (i + 1) + '"' + (i ? "" : ' aria-current="true"') + '><img src="' + esc(url(f, 180)) + '" width="52" height="65" alt=""' + (i > 5 ? ' loading="lazy"' : "") + ' decoding="async"></button>';
});
return { s: s, m: m, n: l.length };
}
var cacheGal = {};
function pintarGaleria(c) {
if (!pista) return;
if (pista.getAttribute("data-yj-color") === c && pista.children.length) return;
if (!cacheGal[c]) cacheGal[c] = htmlGaleria(c);
var h = cacheGal[c];
pista.innerHTML = h.s; minis.innerHTML = h.m;
pista.setAttribute("data-yj-color", c);
pista.scrollLeft = 0; galAct = -1; marcarGal(0);
Q("[data-yj-gal-total]").forEach(function (e) { txt(e, h.n); });
}
function slides() { return $$(".yj-gal__slide", pista); }
function marcarGal(i) {
if (i === galAct) return; galAct = i;
var n = Q("[data-yj-gal-n]")[0]; if (n) txt(n, i + 1);
$$("[data-yj-mini]", minis).forEach(function (m, k) { if (k === i) { m.setAttribute("aria-current", "true"); if (!QA) { var r = m.parentNode; r.scrollTo({ left: m.offsetLeft - r.clientWidth / 2 + m.offsetWidth / 2, top: m.offsetTop - r.clientHeight / 2, behavior: comp }); } } else m.removeAttribute("aria-current"); });
}
function irGal(i, suave) { var l = slides().length; if (!l) return; i = (i + l) % l; pista.scrollTo({ left: i * pista.clientWidth, behavior: suave ? comp : "auto" }); marcarGal(i); }
function arrastrar(p, alSoltar) {
var x0 = null, s0 = 0, movio = false;
p.addEventListener("pointerdown", function (e) { if (e.pointerType !== "mouse" || e.button !== 0) return; x0 = e.clientX; s0 = p.scrollLeft; movio = false; });
window.addEventListener("pointermove", function (e) {
if (x0 === null) return; var dx = e.clientX - x0; if (!movio && Math.abs(dx) < 6) return;
if (!movio) { movio = true; p.classList.add("is-arrastre"); } p.scrollLeft = s0 - dx;
});
window.addEventListener("pointerup", function (e) { if (x0 === null) return; var dx = e.clientX - x0; x0 = null; if (!movio) return; p.classList.remove("is-arrastre"); alSoltar(dx); });
p.addEventListener("click", function (e) { if (movio) { e.preventDefault(); e.stopPropagation(); movio = false; } }, true);
p.addEventListener("dragstart", function (e) { e.preventDefault(); });
}
if (pista) {
pista.addEventListener("scroll", porFrame(function () { marcarGal(Math.round(pista.scrollLeft / pista.clientWidth)); }), { passive: true });
var g0 = 0; pista.addEventListener("pointerdown", function () { g0 = galAct; });
arrastrar(pista, function (dx) { var i = Math.round(pista.scrollLeft / pista.clientWidth); if (i === g0 && Math.abs(dx) > 40) i += dx < 0 ? 1 : -1; irGal(i, true); });
pista.addEventListener("keydown", function (e) { if (e.key === "ArrowRight") { e.preventDefault(); irGal(galAct + 1, true); } else if (e.key === "ArrowLeft") { e.preventDefault(); irGal(galAct - 1, true); } });
minis.addEventListener("click", function (e) { var m = e.target.closest("[data-yj-mini]"); if (m) irGal(+m.getAttribute("data-yj-mini"), true); });
$("[data-yj-gal-prev]").addEventListener("click", function () { irGal(galAct - 1, true); });
$("[data-yj-gal-next]").addEventListener("click", function () { irGal(galAct + 1, true); });
window.addEventListener("resize", porFrame(function () { pista.scrollLeft = galAct * pista.clientWidth; }));
}
function verGaleria() {
var g = $(".yj-gal__main"); if (!g) return false;
var r = g.getBoundingClientRect(), alto = Math.max(1, r.height), vis = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
if (vis >= alto * 0.6) return false;
g.scrollIntoView({ behavior: comp, block: "start" });
return true;
}
YJ.verGaleria = verGaleria;
function htmlColores() {
return colores.map(function (c) {
return '<button type="button" role="radio" class="yj-color' + (colorConStock(c) ? "" : " is-agotado") + '" data-yj-color="' + esc(c) + '" aria-checked="false" aria-label="Color ' + esc(c) + (colorConStock(c) ? "" : " (agotado)") + '"><span class="yj-color__c" style="background-image:url(' + esc(tex(c)) + ')"></span><span class="yj-color__n">' + esc(c) + "</span></button>";
}).join("");
}
function marcarRadios(caja, atrib, valor) {
if (!caja) return; var l = caja.querySelectorAll("[" + atrib + "]");
for (var i = 0; i < l.length; i++) atr(l[i], "aria-checked", l[i].getAttribute(atrib) === String(valor) ? "true" : "false");
}
var boxColores = $("[data-yj-colores]"), boxTallas = $("[data-yj-tallas]"), campoTalla = $("[data-yj-talla-campo]"), boxPaq = $("[data-yj-paq]"), ctaMain = $(".yj-accion [data-yj-comprar]"), accion = $(".yj-accion");
var tieneHover = !!(window.matchMedia && matchMedia("(hover:hover)").matches);
if (boxColores && colores.length) boxColores.innerHTML = htmlColores();
if (boxTallas && tallas.length) boxTallas.innerHTML = tallas.map(function (t) { return '<button type="button" role="radio" class="yj-talla" data-yj-talla="' + esc(t) + '" aria-checked="false">' + esc(t) + "<small>Agotada</small></button>"; }).join("");
var btnTallas = boxTallas ? $$("[data-yj-talla]", boxTallas) : [];
function u0() { return est.unis[0]; }
function pintarTallas() {
var u = u0(), b, t, ok;
for (var i = 0; i < btnTallas.length; i++) {
b = btnTallas[i]; t = b.getAttribute("data-yj-talla"); ok = hayStock(u.c, t);
b.classList.toggle("is-agotada", !ok); atr(b, "aria-disabled", ok ? "false" : "true");
atr(b, "aria-label", "Talla " + t + (ok ? "" : ", agotada")); atr(b, "aria-checked", u.t === t ? "true" : "false");
}
if (campoTalla) { campoTalla.classList.toggle("is-ok", !!u.t); if (u.t) campoTalla.classList.remove("is-falta"); }
}
function pintarRapido() {
marcarRadios(boxColores, "data-yj-color", u0().c);
pintarTallas();
if (dlg && dlg.open) pintarUnis(true);
}
function detalleBarra() { var u = u0(); return est.n > 1 ? "Eliges tono y talla de cada uno" : u.c + (u.t ? " · talla " + u.t : " · elige tu talla"); }
function pintarSeleccion() {
var c = u0().c, t = u0().t;
marcarRadios(boxColores, "data-yj-color", c);
pintarTallas();
Q("[data-yj-color-txt]").forEach(function (e) { txt(e, c); });
Q("[data-yj-talla-txt]").forEach(function (e) { txt(e, t || ""); });
pintarTex();
pintarGaleria(c);
pintarUnis(); pintarPrecios(); pintarDinamicos(); rovingTodo();
}
function pintarTex() { var c = u0().c, u = null; Q("[data-yj-gal-tex]").forEach(function (e) { if (e.__yjC !== c) { e.__yjC = c; e.style.backgroundImage = u || (u = "url(" + tex(c) + ")"); } }); }
function elegirColor(c, i, deUsuaria, origen) {
i = i || 0; var u = est.unis[i]; if (!u) return;
u.c = c; if (u.t && !hayStock(c, u.t)) u.t = null;
if (!deUsuaria) { pintarSeleccion(); return; }
pintarRapido();
luego("sel", function () { pintarSeleccion(); if (origen !== "popup" && i === 0) { verGaleria(); tocoSelector(); } });
track("color_elegido"); if (origen === "popup") track("popup_color"); if (i === 0) marcarDato("color", c);
}
function elegirTalla(t, i, deUsuaria, origen) {
i = i || 0; var u = est.unis[i]; if (!u || !hayStock(u.c, t)) return; u.t = t;
if (!deUsuaria) { pintarSeleccion(); return; }
pintarRapido();
luego("sel", function () { pintarSeleccion(); if (origen === "pagina") trasTalla(); });
track("talla_elegida");
if (origen === "popup") { track("popup_talla"); track("popup_unidad_lista_" + (i + 1)); } else track("talla_pagina");
}
YJ.elegirColor = elegirColor; YJ.elegirTalla = elegirTalla;
function precioBase() { var v = variante(u0().c, u0().t) || vIni; return v && v.p ? v.p / 100 : P[1]; }
function comparar() { var v = variante(u0().c, u0().t) || vIni; return v && v.cp ? v.cp / 100 : 0; }
var DESC = CFG.descuentos || null, FIJ = CFG.descuentosFijos || null;
function pctPara(n) { var p = 0; if (DESC) Object.keys(DESC).forEach(function (k) { if (n >= +k) p = +DESC[k]; }); return p; }
function fijoPara(n) { var m = 0; if (FIJ) Object.keys(FIJ).forEach(function (k) { if (n >= +k) m = Math.max(m, +FIJ[k]); }); return m; }
function total(n) { if (n === 1) return precioBase(); if (FIJ) return Math.max(0, precioBase() * n - fijoPara(n)); if (DESC) return Math.round(precioBase() * n * (100 - pctPara(n)) / 100); return P[n] || precioBase() * n; }
YJ.total = total;
var ANT = CFG.anticipado && CFG.anticipado.activo && CFG.anticipado.codigo && +CFG.anticipado.pct > 0 ? CFG.anticipado : null;
function hayAnticipado() { return !!(ANT && tipoCiudad && (ANT.ciudades || []).indexOf(tipoCiudad) > -1 && esContraEntrega() && total(est.n) >= (ANT.minimo || 0)); }
function baseAnticipado(n) { n = n || est.n; return total(n) + (n === est.n && xtActivo() ? xt.v.price / 100 : 0); }
function totalAnticipado(n) { return Math.round(baseAnticipado(n) * (100 - ANT.pct) / 100); }
YJ.hayAnticipado = hayAnticipado; YJ.totalAnticipado = function (n) { return ANT ? totalAnticipado(n) : null; };
function pintarAnt() {
if (!ANT) return;
var hay = hayAnticipado();
raiz.classList.toggle("yj-hay-ant", hay);
if (accion) accion.classList.toggle("is-ant1", hay && est.n === 1);
if (dlg) dlg.classList.toggle("is-ant", hay && dlgModo !== "carrito");
Q("[data-yj-ant-et]").forEach(function (e) { atr(e, "aria-hidden", hay ? "false" : "true"); });
if (!hay) return;
var ta = totalAnticipado(), det = fmt(ta) + " · ahorras " + fmt(baseAnticipado() - ta);
luego("ant", function () { Q("[data-yj-ant-det]").forEach(function (e) { txt(e, det); }); });
}
function pintarPrecios() {
var n = est.n, tot = total(n), cp = comparar() * n, uni = tot / n, ahorroPaq = precioBase() * n - tot;
Q("[data-yj-precio]").forEach(function (e) { txt(e, fmt(tot)); });
Q("[data-yj-antes]").forEach(function (e) { txt(e, cp > tot ? fmt(cp) : ""); ocultar(e, !(cp > tot)); });
Q("[data-yj-ahorro]").forEach(function (e) { txt(e, cp > tot ? "Ahorras " + fmt(cp - tot) : ""); ocultar(e, !(cp > tot)); });
Q("[data-yj-unitario]").forEach(function (e) { html(e, n > 1 ? "<b>" + fmt(uni) + " c/u</b> · " + fmt(ahorroPaq) + " menos por llevar " + n : ""); });
[1, 2, 3].forEach(function (k) {
var tk = total(k), ak = precioBase() * k - tk;
Q('[data-yj-of-total="' + k + '"]').forEach(function (e) { txt(e, fmt(tk)); });
Q('[data-yj-of-ahorro="' + k + '"]').forEach(function (e) { txt(e, ak > 0 ? "Ahorras " + fmt(ak) : ""); });
Q('[data-yj-of-uni="' + k + '"]').forEach(function (e) { txt(e, k > 1 ? fmt(tk / k) + " c/u" : "Precio normal"); });
});
marcarRadios(boxPaq, "data-yj-n", n);
Q("[data-yj-barra-precio]").forEach(function (e) { txt(e, fmt(tot)); });
if (dlgModo !== "carrito") Q("[data-yj-dlg-total]").forEach(function (e) { txt(e, fmt(tot + (xtActivo() ? xt.v.price / 100 : 0))); });
if (dlg) marcarRadios(dlg, "data-yj-hn", n);
var cuantos = n === 1 ? "1 Lipo Jean" : n + " Lipo Jeans";
Q("[data-yj-barra-nom]").forEach(function (e) { txt(e, cuantos); });
var det = detalleBarra(); Q("[data-yj-barra-det]").forEach(function (e) { txt(e, det); });
if (accion) accion.classList.toggle("is-multi", n > 1);
Q("[data-yj-paq-sig]").forEach(function (e) { atr(e, "data-n", String(n)); });
Q("[data-yj-fin-sel]").forEach(function (e) { txt(e, cuantos + " · " + fmt(tot)); });
pintarAnt();
pintarRegalos();
}
function pintarUnis(rapido) {
if (!dlg || !filas) return;
atr(unisBox, "data-n", String(est.n));
for (var i = 0; i < est.n; i++) {
var f = filas[i], u = est.unis[i], k, b, t, ok;
for (k = 0; k < f.cs.length; k++) atr(f.cs[k], "aria-checked", f.cs[k].getAttribute("data-yj-uc") === u.c ? "true" : "false");
for (k = 0; k < f.ts.length; k++) {
b = f.ts[k]; t = b.getAttribute("data-yj-ut"); ok = hayStock(u.c, t);
b.classList.toggle("is-agotada", !ok); atr(b, "aria-disabled", ok ? "false" : "true");
atr(b, "aria-label", "Talla " + t + (ok ? "" : ", agotada")); atr(b, "aria-checked", u.t === t ? "true" : "false");
}
if (rapido) continue;
f.el.classList.toggle("is-ok", !!u.t);
if (u.t) f.el.classList.remove("is-falta");
txt(f.sel, u.c + " · " + (u.t ? "talla " + u.t : "elige talla"));
}
if (!rapido) pintarRegaloTalla();
}
function elegirPaquete(n, origen, calla) {
var antes = est.n; est.n = n; ajustarUnis();
function resto() {
pintarUnis(); pintarPrecios(); pintarDinamicos(); rovingTodo();
if (!origen) return;
avisarCta(origen);
if (n > antes && !reducido) Q(".yj-regalo").forEach(function (li) { var d = +li.getAttribute("data-desde"); if (d > antes && d <= n) { reanimar(li, "is-nuevo"); destellos(li); } });
}
if (origen || calla) {
marcarRadios(boxPaq, "data-yj-n", n); if (dlg) marcarRadios(dlg, "data-yj-hn", n);
luego("paq", resto);
track("oferta_elegida_" + n); if (calla) track("popup_cantidad"); marcarDato("paquete", n);
} else resto();
}
YJ.elegirPaquete = elegirPaquete;
function rebotar(x) { if (!x || reducido) return; reanimar(x, "is-rebote"); clearTimeout(x.__yjReb); x.__yjReb = setTimeout(function () { x.classList.remove("is-rebote"); }, 1900); }
function avisarCta(of) {
var b = ctaMain, barra = Q("[data-yj-barra]")[0];
if (!b) return;
var r = b.getBoundingClientRect(), h = window.innerHeight || document.documentElement.clientHeight;
if (of && of.classList && !reducido) reanimar(of, "is-elegida");
rebotar(b); if (barra && barra.classList.contains("is-on")) rebotar($("[data-yj-comprar]", barra));
if (r.bottom > h - 12 || r.top < 0) { var a = b.closest("[data-yj-cta-principal]") || b; try { a.scrollIntoView({ behavior: comp, block: "nearest" }); } catch (e) { a.scrollIntoView(false); } }
}
YJ.avisarCta = avisarCta;
var ESTRELLA = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 1.5c.6 5.4 3.6 9.4 10.5 10.5-6.9 1.1-9.9 5.1-10.5 10.5-.6-5.4-3.6-9.4-10.5-10.5C8.4 10.9 11.4 6.9 12 1.5z"/></svg>';
var PUNTOS = [[-0.15, -0.2, 10, 0], [0.55, -0.42, 7, 90], [1.12, -0.12, 9, 170], [1.2, 0.72, 6, 260], [0.42, 1.18, 8, 340], [-0.22, 0.8, 6, 430]];
function destellos(li) {
var box = $("[data-yj-fx]"), img = li && li.querySelector(".yj-regalo__img, .yj-med"); if (!box || !img || reducido) return;
var rb = box.getBoundingClientRect(), ri = img.getBoundingClientRect(), f = document.createDocumentFragment();
if (ri.bottom < 0 || ri.top > innerHeight) return;
PUNTOS.forEach(function (p) {
var s = document.createElement("i"); s.className = "yj-estrella"; s.innerHTML = ESTRELLA;
s.style.cssText = "left:" + (ri.left - rb.left + p[0] * ri.width).toFixed(1) + "px;top:" + (ri.top - rb.top + p[1] * ri.height).toFixed(1) + "px;--t:" + p[2] + "px;animation-delay:" + p[3] + "ms";
s.addEventListener("animationend", function () { if (this.parentNode) this.parentNode.removeChild(this); });
f.appendChild(s);
});
box.appendChild(f);
}
YJ.destellos = destellos;
var REG = CFG.regalos || [];
function regalosDe(n) { return REG.filter(function (r) { return r.desde <= n; }); }
function regaloPrenda(n) { return regalosDe(n).filter(function (r) { return r.tallas && r.tallas.length; })[0] || null; }
function pintarRegalos() {
var n = est.n, si = regalosDe(n), sig = REG.filter(function (r) { return r.desde > n; })[0];
Q(".yj-regalo").forEach(function (li) { li.classList.toggle("is-si", +li.getAttribute("data-desde") <= n); });
Q("[data-yj-reg-n]").forEach(function (e) { txt(e, si.length); });
var esc_ = "scaleX(" + (REG.length ? si.length / REG.length : 1).toFixed(3) + ")";
Q("[data-yj-reg-fill]").forEach(function (e) { if (e.__yjT !== esc_) { e.__yjT = esc_; e.style.transform = esc_; } });
var l = sig ? "Lleva " + sig.desde + " jeans y desbloqueas: <b>" + esc(sig.nombre.charAt(0).toLowerCase() + sig.nombre.slice(1)) + "</b>" + (n === 1 ? ", mi reina." : ".") : "<b>¡Desbloqueaste los " + REG.length + " regalos, mi reina!</b> ✨";
Q("[data-yj-reg-linea]").forEach(function (e) { html(e, l); });
Q("[data-yj-llega] li[data-desde]").forEach(function (li) { li.classList.toggle("is-no", +li.getAttribute("data-desde") > n); });
Q("[data-yj-llega-n]").forEach(function (e) { txt(e, n === 1 ? "1 jean" : n + " jeans"); });
Q("[data-yj-llega-jeans]").forEach(function (e) { txt(e, n === 1 ? "Tu Lipo Jean" : "Tus " + n + " Lipo Jeans"); });
}
function pintarRegaloTalla() {
var g = regaloPrenda(est.n);
if (g && g.tallas.length === 1) est.regaloTalla = g.tallas[0];
if (!regt) return;
regt.el.classList.toggle("is-on", !!g); if (!g) return;
if (g.tallas.length > 1 && g.tallas.indexOf(est.regaloTalla) < 0) est.regaloTalla = null;
if (regt.unica) return;
marcarRadios(regt.el, "data-yj-regt-t", est.regaloTalla);
regt.el.classList.toggle("is-ok", !!est.regaloTalla);
if (est.regaloTalla) regt.el.classList.remove("is-falta");
txt(regt.sel, !est.regaloTalla ? "elige su talla" : /^talla/i.test(est.regaloTalla) ? est.regaloTalla.toLowerCase() : "talla " + est.regaloTalla);
}
var CONT = CFG.contador || { minutos: 15, avisoCada: 5 }, relojDur = (CONT.minutos || 15) * 60000, relojIni = Date.now(), relojT = null, avisados = {};
var EXP = ((CFG.envio || {}).express) || null;
var GRATIS = !(CFG.envio && CFG.envio.gratis === false);
var EXPC = GRATIS && !!(CFG.envio && CFG.envio.contador);
YJ.envioGratis = GRATIS; YJ.envioContador = EXPC;
function restante() { return Math.max(0, relojIni + relojDur - Date.now()); }
function mmss(ms) { var s = Math.ceil(ms / 1000); return pad(Math.floor(s / 60)) + ":" + pad(s % 60); }
function esExpress() { var cn = norm(ciudad); return !!(EXP && cn && (EXP.ciudades || []).some(function (x) { return cn.indexOf(x) > -1; })); }
function tic() {
var r = restante(), trans = relojDur - r, paso = (CONT.avisoCada || 5) * 60000, nuevo = null;
for (var k = paso; k < relojDur; k += paso) if (trans >= k && !avisados[k]) { avisados[k] = 1; nuevo = k; track("timer_" + Math.round(k / 60000) + "min"); }
if (r <= 0 && !avisados.fin) { avisados.fin = 1; nuevo = "fin"; track("timer_fin"); if (relojT) { clearInterval(relojT); relojT = null; } }
if (nuevo === "fin") aviso("Se terminó el tiempo, mi reina. <b>¡Aún puedes pedir tu Lipo Jean!</b> 💗", 6000);
else if (nuevo) aviso("Te quedan " + Math.round((relojDur - nuevo) / 60000) + " minutos para tus regalos" + (EXPC ? " y envío gratis" : "") + " ✨", 5000);
pintarReloj();
}
function pintarReloj() {
var r = restante(), fin = r <= 0, t = mmss(r), conExp = EXPC && tipoCiudad !== "otra";
var largo = fin ? "Se acabó el tiempo, mi reina" : conExp ? "Tus regalos y el envío express gratis te esperan:" : "Tus regalos te esperan:";
var mini = fin ? "Se acabó el tiempo" : conExp ? "Regalos y express gratis:" : "Tus regalos:";
var cifra = fin ? "¡Aún puedes pedir!" : t;
Q("[data-yj-reloj]").forEach(function (e) {
var s = e.__yjS;
if (!s) { var c0 = $("[data-yj-reloj-t]", e); if (!c0) return; if (!c0.querySelector("b")) c0.innerHTML = "<span></span> <b></b>"; s = e.__yjS = { a: c0.querySelector("span"), b: c0.querySelector("b") }; }
e.classList.toggle("is-fin", fin); txt(s.a, e.hasAttribute("data-yj-reloj-mini") ? mini : largo); atr(s.b, "data-t", cifra);
});
var corto = fin ? "" : conExp ? " · regalos y express gratis" : " · tus regalos te esperan";
Q("[data-yj-barra-reloj]").forEach(function (e) { atr(e, "data-t", cifra); txt(e, corto); e.classList.toggle("is-fin", fin); });
var box = Q("[data-yj-express]")[0];
if (box && EXP) {
var on = esExpress() && (!GRATIS || EXPC); ocultar(box, !on);
if (on) {
var c = /soacha/.test(norm(ciudad)) ? "Soacha" : "Bogotá", x = $("[data-yj-express-t]", box), corre = EXPC && !fin;
html(x, !GRATIS ? "Envío express en " + c + ": <b>" + fmt(EXP.tarifa || 10000) + "</b> · " + LLEGA_CE + " · pagas al recibir"
: !EXPC ? "<b>Envío gratis</b> en " + c + " · " + LLEGA_CE + " · pagas al recibir (contra entrega)"
: fin ? "Envío express en " + c + ": " + fmt(EXP.tarifa || 10000) + " · " + LLEGA_CE + "" : "Envío express en " + c + " <b>gratis</b> si pides en los próximos <b data-yj-exp-n></b>");
if (corre) { var xn = x.querySelector("[data-yj-exp-n]"); if (xn) atr(xn, "data-t", t); }
box.classList.toggle("is-fin", EXPC && fin);
}
}
}
function initReloj() {
tic();
relojT = setInterval(function () { if (!document.hidden) tic(); }, 1000);
}
YJ.adelantarReloj = function (ms) { relojIni -= ms; tic(); };
YJ.restante = restante;
YJ.expressGratis = function () { return EXPC && esExpress() && restante() > 0; };
var ciudad = "", region = "", ciudadGeo = "", regionGeo = "", tipoCiudad = null, ciuManual = false;
var CIUS = { bogota: "Bogotá", soacha: "Soacha", otra: "Otra ciudad" };
function tipoDe(c) { var n = norm(c); return /bogot/.test(n) ? "bogota" : /soacha/.test(n) ? "soacha" : n ? "otra" : null; }
function esContraEntrega() { return tipoCiudad === "bogota" || tipoCiudad === "soacha"; }
function htmlCiudades(suf) {
var id = "yj-ciu-panel" + (suf || "");
return '<div class="yj-ciu__conf"><p class="yj-ciu__linea" data-yj-ciu-conf aria-live="polite">' + ico("pin") + "<span></span></p>"
+ '<button type="button" class="yj-ciu__cambiar" data-yj-ciu-cambiar aria-expanded="false" aria-controls="' + id + '">Cambiar</button></div>'
+ '<div class="yj-ciu__panel" id="' + id + '" data-yj-ciu-panel hidden><div class="yj-ciu__op" data-yj-ciudades role="radiogroup" aria-label="Ciudad de entrega">'
+ Object.keys(CIUS).map(function (k) { return '<button type="button" role="radio" class="yj-ciu__b" data-yj-ciu="' + k + '" aria-checked="' + (tipoCiudad === k) + '">' + CIUS[k] + "</button>"; }).join("")
+ '</div><p class="yj-ciu__nota" data-yj-ciu-nota></p></div>';
}
function elegirCiudad(k, deUsuaria) {
if (!CIUS[k]) return;
tipoCiudad = k;
if (k !== "otra") { ciudad = CIUS[k]; region = ""; }
else { var g = tipoDe(ciudadGeo); ciudad = g === "otra" ? ciudadGeo : ""; region = ciudad ? regionGeo : ""; }
if (deUsuaria) {
ciuManual = true; guardarSes("yj-ciu", k); track("ciudad_" + k);
var f = raiz.querySelectorAll(".yj-ciu.is-falta"); for (var i = 0; i < f.length; i++) f[i].classList.remove("is-falta");
}
marcarDato("ciudad", k); marcarDato("pago", esContraEntrega() ? "contra_entrega" : "anticipado");
pintarEntrega();
}
YJ.elegirCiudad = elegirCiudad;
YJ.ciudad = function () { return { tipo: tipoCiudad, ciudad: ciudad, manual: ciuManual }; };
function abrirCambiar(btn, abre, sola) {
var caja = btn.closest(".yj-ciu"), panel = caja && $("[data-yj-ciu-panel]", caja); if (!panel) return;
panel.hidden = !abre; btn.setAttribute("aria-expanded", abre ? "true" : "false"); btn.textContent = abre ? "Listo" : "Cambiar";
if (abre && !sola) track("ciudad_cambiar");
}
function pintarCiudad() {
Q("[data-yj-ciu]").forEach(function (b) { atr(b, "aria-checked", b.getAttribute("data-yj-ciu") === tipoCiudad ? "true" : "false"); });
var ce = esContraEntrega();
var conf = !tipoCiudad ? "<b>Elige tu ciudad</b> · Bogotá, Soacha u otra" : ce ? "<b>Te llega a " + esc(CIUS[tipoCiudad]) + "</b> · " + ((CFG.releasit || {}).activo !== false ? "Pagas al recibir" : "Contra Entrega al pagar") : "<b>Te llega a " + esc(ciudad || "tu ciudad") + "</b> · Pago seguro en línea";
Q("[data-yj-ciu-conf] > span").forEach(function (e) { html(e, conf); });
var nota = GRATIS && !EXPC
? (ce ? "<b>Envío gratis</b> · " + LLEGA_CE + " · pagas al recibir (contra entrega): en el pago elige <b>Contra Entrega</b>." : "<b>Envío gratis</b> · llega en 3 a 5 días · pagas en línea, seguro.")
: !GRATIS
? (ce ? "<b>En el pago elige Contra Entrega y pagas al recibir.</b> Envío express $10.000 · " + LLEGA_CE + "." : "<b>Pago en línea:</b> tarjeta, PSE, Nequi, Addi… · el envío con Interrapidísimo lo pagas al recibir.")
: ce ? "<b>Pagas al recibir</b> (contra entrega) · " + LLEGA_CE + "." : "<b>Pagas en línea, seguro:</b> tarjeta, PSE, Nequi, Daviplata, Addi o Sistecrédito · envío gratis.";
if (!tipoCiudad) nota = GRATIS ? "<b>Envío gratis a toda Colombia.</b> Elige tu ciudad para ver cuándo llega y cómo pagas." : "Elige tu ciudad para ver el envío y cómo pagas.";
Q("[data-yj-ciu-nota]").forEach(function (e) { html(e, nota); });
var ft = !tipoCiudad ? "CONFIRMAR PEDIDO" : ce ? "PEDIR Y PAGAR AL RECIBIR" : "IR A PAGAR SEGURO";
Q("[data-yj-fin-txt]").forEach(function (e) { txt(e, ft); e.parentNode.classList.toggle("is-largo", ft.length > 16); });
Q("[data-yj-zona]").forEach(function (e) { ocultar(e, e.getAttribute("data-yj-zona") !== (ce ? "ce" : "linea")); });
pintarAnt();
}
var festivosCache = {};
function festivos(y) {
if (festivosCache[y]) return festivosCache[y];
var f = {}, k = function (d) { return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate(); };
var lunes = function (d) { d.setDate(d.getDate() + (8 - d.getDay()) % 7); return d; };
[[1, 1], [5, 1], [7, 20], [8, 7], [12, 8], [12, 25]].forEach(function (m) { f[k(new Date(y, m[0] - 1, m[1]))] = 1; });
[[1, 6], [3, 19], [6, 29], [8, 15], [10, 12], [11, 1], [11, 11]].forEach(function (m) { f[k(lunes(new Date(y, m[0] - 1, m[1])))] = 1; });
var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, ff = Math.floor((b + 8) / 25), g = Math.floor((b - ff + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), kk = c % 4, l = (32 + 2 * e + 2 * i - h - kk) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
var pascua = new Date(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, (h + l - 7 * m + 114) % 31 + 1);
[-3, -2, 43, 64, 71].forEach(function (o) { var x = new Date(pascua); x.setDate(x.getDate() + o); f[k(x)] = 1; });
return (festivosCache[y] = f);
}
function habil(d) { if ((CFG.entrega || {}).todosLosDias) return true; var w = d.getDay(); return w !== 0 && w !== 6 && !festivos(d.getFullYear())[d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()]; }
function sumarHabiles(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (habil(d)) n--; } return d; }
YJ.festivos = festivos; YJ.sumarHabiles = sumarHabiles;
function tramo() {
var E = CFG.entrega || {}, cn = " " + norm(ciudad) + " ", dn = norm(region), l = E.tramos || [];
for (var i = 0; i < l.length; i++) {
var t = l[i];
if ((t.ciudades || []).some(function (x) { return cn.indexOf(" " + x + " ") > -1 || cn.indexOf(" " + x) > -1; })) return t;
if (dn && !(t.express) && (t.deptos || []).some(function (x) { return dn.indexOf(x) > -1; })) return t;
}
return { dias: E.restoDias || [3, 5], naturales: !!E.restoNaturales };
}
YJ.tramo = function (c, r) { var a = ciudad, b = region; ciudad = c || ""; region = r || ""; var t = tramo(); ciudad = a; region = b; return t; };
function pintarEntrega() {
var E = CFG.entrega || {}, cn = norm(ciudad), tr = tramo(), r = tr.dias, hoy = new Date();
var extra = !habil(hoy) || hoy.getHours() >= (E.corteHora || 14) ? 1 : 0;
var a = r[0] === 0 && !extra ? new Date(hoy) : sumarHabiles(hoy, Math.max(r[0], 1) + extra - (r[0] === 0 ? 1 : 0)), b = sumarHabiles(hoy, r[1] + extra);
if (tr.naturales || tr.sinCorte) { a = new Date(hoy); a.setDate(a.getDate() + r[0]); b = new Date(hoy); b.setDate(b.getDate() + r[1]); }
var dia = function (d) { var m = new Date(hoy); m.setDate(m.getDate() + 1); return d.toDateString() === hoy.toDateString() ? "hoy" : d.toDateString() === m.toDateString() ? "mañana" : null; };
var f = function (d, mes) { var x = dia(d); if (x) return x; try { return "el " + d.toLocaleDateString("es-CO", mes ? { weekday: "short", day: "numeric", month: "short" } : { weekday: "short", day: "numeric" }).replace(/[.,]/g, "").replace(/ de /g, " "); } catch (e) { return "el " + d.getDate() + "/" + (d.getMonth() + 1); } };
var fechas = "entre " + f(a, a.getMonth() !== b.getMonth() && a.getMonth() !== hoy.getMonth()) + " y " + f(b, b.getMonth() !== hoy.getMonth());
if (!tipoCiudad) { var ex = ((E.tramos || []).filter(function (x) { return x.express; })[0] || {}).dias || r; fechas = "en " + Math.min(ex[0] || r[0], r[0]) + " a " + r[1] + " días"; }
Q("[data-yj-fecha]").forEach(function (e) { txt(e, fechas); });
Q("[data-yj-ciudad]").forEach(function (e) { txt(e, ciudad || "tu ciudad"); });
Q("[data-yj-ruta-ciudad]").forEach(function (e) { txt(e, ciudad || "Tu casa"); });
Q("[data-yj-entrega-via]").forEach(function (e) { txt(e, tr.express ? (!GRATIS ? "· express " + fmt((EXP && EXP.tarifa) || 10000) : EXPC ? "· envío express" : "· envío gratis") : (GRATIS ? "· envío gratis" : "· con Interrapidísimo")); });
pintarCiudad(); pintarReloj();
}
function detectarCiudad() {
var g = leerSes("yj-geo-c");
if (g !== null) { ciudadGeo = g; regionGeo = leerSes("yj-geo-r") || ""; YJ.geo = g ? "sesion" : "sesion-sin-ciudad"; prellenar(); return; }
if (!window.fetch || QA) return;
var ctl = window.AbortController ? new AbortController() : null, hecho = false;
var fin = function (r, motivo) {
if (hecho) return; hecho = true; clearTimeout(t);
ciudadGeo = r ? r.ciudad : ""; regionGeo = r ? r.region : ""; YJ.geo = motivo;
if (motivo !== "error" && motivo !== "tiempo") { guardarSes("yj-geo-c", ciudadGeo); guardarSes("yj-geo-r", regionGeo); }
track("geo_" + motivo); prellenar();
};
var t = setTimeout(function () { fin(null, "tiempo"); if (ctl) try { ctl.abort(); } catch (e) {} }, GEO_ESPERA);
fetch("https://get.geojs.io/v1/ip/geo.json", ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.ok ? r.json() : null; }).then(function (g) {
var r = geoConfiable(g); fin(r, r ? "ok" : g ? "sin_confianza" : "error");
}).catch(function () { fin(null, "error"); });
}
function prellenar() {
if (ciuManual) return;
var k = tipoDe(ciudadGeo);
if (k) { $$(".yj-compra [data-yj-ciu-cambiar]").forEach(function (b) { if (b.__yjSola && b.getAttribute("aria-expanded") === "true") abrirCambiar(b, false, true); b.__yjSola = false; }); elegirCiudad(k, false); }
else sinCiudad(true);
}
function sinCiudad(abrir) {
tipoCiudad = null; ciudad = ""; region = "";
marcarDato("ciudad", "sin_detectar"); pintarEntrega();
if (abrir) $$(".yj-compra [data-yj-ciu-cambiar]").forEach(function (b) { if (b.getAttribute("aria-expanded") !== "true") { abrirCambiar(b, true, true); b.__yjSola = true; } });
}
YJ.sinCiudad = sinCiudad;
YJ.otraCiudadQA = function () { ciudadGeo = ""; regionGeo = ""; ciuManual = false; try { sessionStorage.removeItem("yj-ciu"); } catch (e) {} $$(".yj-compra [data-yj-ciu-cambiar]").forEach(function (b) { if (b.getAttribute("aria-expanded") === "true") abrirCambiar(b, false, true); b.__yjSola = false; }); elegirCiudad("otra", false); };
var GEO = CFG.geo || {}, GEO_RADIO = +GEO.radioMaxKm > 0 ? +GEO.radioMaxKm : 50, GEO_ESPERA = +GEO.esperaMs > 0 ? +GEO.esperaMs : 3500;
function geoConfiable(g) {
if (!g || g.country_code !== "CO") return null;
var c = String(g.city || "").trim(), acc = parseFloat(g.accuracy);
if (!c || /^\d/.test(c) || c.length > 60 || !isFinite(acc) || acc <= 0 || acc > GEO_RADIO) return null;
if (/bogot/i.test(c)) c = "Bogotá";
return { ciudad: c, region: String(g.region || "") };
}
YJ.geoConfiable = geoConfiable;
YJ.ponerCiudadGeo = function (c, r) { ciudadGeo = c || ""; regionGeo = r || ""; ciuManual = false; try { sessionStorage.removeItem("yj-ciu"); } catch (e) {} prellenar(); };
var RAIZ_TIENDA = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
function pedir(ruta, cuerpo, ms) {
var ctl = window.AbortController ? new AbortController() : null, t = ctl ? setTimeout(function () { ctl.abort(); }, ms || 15000) : 0;
var op = { credentials: "same-origin", headers: { Accept: "application/json" } };
if (cuerpo) { op.method = "POST"; op.headers["Content-Type"] = "application/json"; op.body = JSON.stringify(cuerpo); }
if (ctl) op.signal = ctl.signal;
return fetch(RAIZ_TIENDA + ruta, op).then(function (r) {
clearTimeout(t);
return r.json().catch(function () { return null; }).then(function (j) { if (!r.ok) { var e = new Error((j && (j.description || j.message)) || "HTTP " + r.status); e.status = r.status; throw e; } return j; });
}, function (e) { clearTimeout(t); var x = new Error(e && e.name === "AbortError" ? "tiempo" : "red"); x.status = 0; throw x; });
}
function conCodigo(c) { return !!(c && (((c.discount_codes || []).some(function (d) { return d && d.applicable !== false; })) || ((c.cart_level_discount_applications || []).some(function (d) { return d && (d.type === "discount_code" || d.discount_code || d.code); })))); }
YJ.conCodigo = conCodigo;
function esLipo(it) { var pid = DATOS.producto && DATOS.producto.id; return pid ? it.product_id === pid : VARS.some(function (v) { return String(v.id) === String(it.variant_id || it.id); }); }
function limpiarPrevios() {
return pedir("cart.js").then(function (c) {
var up = {}, n = 0;
((c && c.items) || []).forEach(function (it) { if (it.properties && it.properties._yj && (esLipo(it) || it.properties._yj_top)) { up[it.key] = 0; n++; } });
return n ? pedir("cart/update.js", { updates: up }) : null;
}).catch(function () { return null; });
}
var carritoN = +(raiz.getAttribute("data-yj-carrito-n") || 0);
function pintarCarrito(n) {
if (typeof n === "number") carritoN = n;
$$("[data-yj-car-n]").forEach(function (e) { e.textContent = carritoN; e.classList.toggle("is-cero", !carritoN); });
$$("[data-yj-carrito]").forEach(function (b) { b.setAttribute("aria-label", "Tu carrito: " + carritoN + (carritoN === 1 ? " producto" : " productos")); });
}
function avisarCarrito(c) {
pintarCarrito(c.item_count || 0);
try { document.dispatchEvent(new CustomEvent("cart:update", { bubbles: true, detail: { resource: c, sourceId: "yj-lipo-jean", data: { itemCount: c.item_count, source: "yj-lipo-jean" } } })); } catch (e) {}
}
function refrescarCarrito() { return pedir("cart.js").then(function (c) { avisarCarrito(c); return c; }); }
YJ.refrescarCarrito = refrescarCarrito;
function pedido(anticipado) {
var dentro = restante() > 0, reg = (dentro || CONT.regalosAlTerminar !== false) ? regalosDe(est.n).map(function (r) { return r.nombre; }) : [];
var agg = {}, orden = [], g = regaloPrenda(est.n);
est.unis.forEach(function (u) { var v = variante(u.c, u.t); if (!agg[v.id]) { agg[v.id] = 0; orden.push(v.id); } agg[v.id]++; });
var items = orden.map(function (id, i) {
var it = { id: +id, quantity: agg[id], properties: { "_yj": "1" } };
if (i === 0) {
it.properties["Paquete"] = est.n === 1 ? "1 Lipo Jean" : est.n + " Lipo Jeans (" + fmt(total(est.n)) + ")";
if (reg.length) it.properties["Regalos"] = reg.join(" + ");
if (g && reg.length) it.properties["Talla de la prenda de obsequio"] = est.regaloTalla || g.tallas[0];
if (YJ.expressGratis()) it.properties["Envío express"] = "Gratis (pidió dentro de los " + (CONT.minutos || 15) + " min)";
if (anticipado && ANT) it.properties["Pago"] = "Anticipado con " + ANT.pct + " % de descuento (" + ANT.codigo + ")";
it.properties["_entrega"] = tipoCiudad || "";
it.properties["_contador"] = dentro ? "dentro" : "terminado";
}
return it;
});
if (xtActivo()) items.push({ id: +xt.v.id, quantity: 1, properties: { "_yj": "1", "_yj_top": "1" } });
return { items: items };
}
YJ.pedido = pedido;
var RS = CFG.releasit || { activo: true, espera: 8000 };
function abrirReleasit(token) {
return new Promise(function (ok, mal) {
if (!RS.activo || !token) { mal(new Error("sin releasit")); return; }
var t0 = Date.now(), max = YJ.esperaReleasit || RS.espera || 8000;
(function intentar() {
var r = window._rsiV2;
if (r && typeof r.setState === "function" && r.cartService && typeof r.cartService.getCart === "function") {
var id = /^gid:/.test(token) ? token : "gid://shopify/Cart/" + token;
Promise.resolve(r.cartService.getCart(id)).then(function (x) {
var cart = x && x.data && x.data.cart, ed = cart && cart.lines && cart.lines.edges;
if (!ed || !ed.length) throw new Error("carrito vacío");
var m = ed[0].node.merchandise, idn = function (g) { return Number(String(g || "").split("/").pop()) || undefined; };
r.setState({ cartInfo: cart, currentVariantId: idn(m && m.id), currentProductId: idn(m && m.product && m.product.id), isOpen: true });
ok();
}).catch(mal);
return;
}
if (Date.now() - t0 < max) setTimeout(intentar, 150); else mal(new Error("releasit no cargó"));
})();
});
}
function urlCheckout(codigo) {
var u = RAIZ_TIENDA + "checkout";
try { u = YJ_CHECKOUT.url(RAIZ_TIENDA, { tipo: tipoCiudad, ciudad: ciudad, region: region }, codigo); } catch (e) {}
return u;
}
YJ.urlCheckout = urlCheckout;
function irCheckout(codigo) { track("checkout_redirect"); YJ.ultimaRuta = codigo ? "checkout-anticipado" : "checkout"; var u = urlCheckout(codigo); YJ.ultimaUrl = u; location.href = u; }
var enviando = false, errTok = 0;
function errorCompra(e, btn) {
enviando = false; errTok++; if (btn) btn.removeAttribute("aria-busy");
var por = e.status === 0 ? (e.message === "tiempo" ? "La conexión está muy lenta" : "Parece que se fue la conexión") : e.status === 422 ? "Una de las tallas se acaba de agotar o no quedan suficientes unidades" : "No pudimos preparar tu pedido";
if (window.console) console.warn("yj carrito", e.status, e.message);
var msg = esc(por) + ". Intenta de nuevo, mi reina." + (TIENDA.whatsappVisible ? " Si sigue fallando, llámanos al " + esc(TIENDA.whatsappVisible) + "." : "");
var err = $("[data-yj-dlg][open] [data-yj-dlg-err]"); if (err) err.textContent = msg.replace(/<[^>]+>/g, "");
aviso(msg, 10000);
}
function finalizar(btn, agregar, anticipado) {
if (enviando) return;
if (!tipoCiudad && !agregar) { abrirDlg("carrito", null, btn); return; }
popAutoFin("fue_a_pagar");
anticipado = !!(anticipado && agregar && hayAnticipado());
var cuerpo = agregar ? pedido(anticipado) : null; if (cuerpo) YJ.ultimoPedido = cuerpo;
enviando = true; if (btn) btn.setAttribute("aria-busy", "true");
track("comprar_click"); marcarDato("pago", esContraEntrega() && !anticipado ? "contra_entrega" : anticipado ? "anticipado_10" : "anticipado");
var paso = agregar ? limpiarPrevios().then(function () { return pedir("cart/add.js", cuerpo); }) : Promise.resolve();
paso.then(function () { return (agregar && !anticipado ? pedir("cart/update.js", { discount: "" }).catch(function () { return pedir("cart.js"); }) : pedir("cart.js")).catch(function () { return null; }); })
.then(function (c) {
if (c && agregar && !anticipado) { YJ.codigoPegado = conCodigo(c); if (YJ.codigoPegado) track("codigo_no_quitado"); }
if (c) avisarCarrito(c);
dlgCompro = true; cerrarDlg(true);
if (anticipado) { irCheckout(ANT.codigo); return; }
if (!esContraEntrega() || !RS.activo) { irCheckout(); return; }
aviso("Abriendo tu pedido contra entrega…", 4000);
return abrirReleasit(c && c.token).then(function () {
enviando = false; if (btn) btn.removeAttribute("aria-busy");
YJ.ultimaRuta = "releasit"; track("releasit_abierto");
}, function (e) { if (window.console) console.warn("yj releasit", e && e.message); irCheckout(); });
})
.catch(function (e) { errorCompra(e, btn); });
}
function tallasALaVista() {
if (!boxTallas) return false;
var r = boxTallas.getBoundingClientRect(), h = innerHeight;
return r.height > 0 && r.top >= 0 && r.bottom <= h - 70;
}
function faltaTalla(btn) {
track("falta_talla");
if (!campoTalla) return;
var r = campoTalla.getBoundingClientRect();
if (r.top < 8 || r.bottom > innerHeight - 80) try { campoTalla.scrollIntoView({ behavior: comp, block: "center" }); } catch (e) { campoTalla.scrollIntoView(); }
reanimar(campoTalla, "is-falta");
var av = $("[data-yj-talla-aviso]", campoTalla); if (av) { av.setAttribute("role", "alert"); av.removeAttribute("aria-hidden"); }
}
function comprar(btn, lejos, anticipado) {
if (enviando) return;
if (est.n > 1) { abrirTras(btn, function () { abrirDlg("unidades", null, btn); }); return; }
var u = u0();
anticipado = !!(anticipado && hayAnticipado());
if (u.t && hayStock(u.c, u.t)) { track("compra_directa_1"); track(anticipado ? "directa_pagar_anticipado" : esContraEntrega() ? "directa_pagar_contraentrega" : "directa_pagar_linea"); finalizar(btn, true, anticipado); return; }
if (lejos && !tallasALaVista()) { abrirTras(btn, function () { abrirDlg("unidades", null, btn); }); return; }
faltaTalla(btn);
}
function comprarBarra(btn) {
if (enviando) return;
track("barra_comprar");
comprar(btn, true);
}
window.addEventListener("pageshow", function (e) { if (e.persisted) { enviando = false; $$("[aria-busy]").forEach(function (b) { b.removeAttribute("aria-busy"); }); refrescarCarrito().catch(function () {}); } });
var dlg = null, dlgModo = null, dlgOrigen = null, dlgHist = false, dlgCompro = false, filas = null, unisBox = null, regt = null;
var XT = TIENDA.casillaTop && TIENDA.casillaTop.activa ? TIENDA.casillaTop : null, xt = null;
function xtActivo() { return !!(xt && xt.on && est.n > 1 && dlgModo === "unidades"); }
function xtColor(s) { s = String(s || "").toLowerCase(); return s.charAt(0).toUpperCase() + s.slice(1); }
function pintarXt() {
if (!xt) return;
xt.el.classList.toggle("is-on", xt.on);
txt(xt.p, "+ " + fmt(xt.v.price / 100) + (xt.on ? " · " + xtColor(xt.v.title) : " · tú eliges el color"));
for (var i = 0; i < xt.bs.length; i++) atr(xt.bs[i], "aria-checked", xt.bs[i].getAttribute("data-yj-xt-v") === String(xt.v.id) ? "true" : "false");
}
function initXt() {
var el = XT && $("[data-yj-xt]", dlg); if (!el || !window.fetch) return;
fetch(RAIZ_TIENDA + "products/" + XT.handle + ".js", { credentials: "same-origin", headers: { Accept: "application/json" } }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
var vs = (p.variants || []).filter(function (v) { return v.available && v.price > 0; });
if (!vs.length || (p.options || []).length !== 1) return;
var cs = $("[data-yj-xt-cs]", el), c = $("[data-yj-xt-c]", el);
cs.innerHTML = vs.map(function (v) { return '<button type="button" role="radio" class="yj-xt__c" data-yj-xt-v="' + v.id + '" aria-checked="false">' + esc(xtColor(v.title)) + "</button>"; }).join("");
xt = { el: el, c: c, p: $("[data-yj-xt-p]", el), vs: vs, v: vs[0], on: false, bs: $$("[data-yj-xt-v]", cs) };
c.checked = false;
c.addEventListener("change", function () { xt.on = !!c.checked; track(xt.on ? "top_casilla_on" : "top_casilla_off"); pintarXt(); pintarPrecios(); rovingTodo(); });
pintarXt(); el.classList.add("is-lista"); YJ.casillaTop = xt;
}).catch(function () {});
}
function modalizar(d) {
if (typeof d.showModal === "function") return;
d.classList.add("yj-dlg--sin");
d.showModal = function () { d.setAttribute("open", ""); d.open = true; };
d.close = function () { if (!d.open) return; d.removeAttribute("open"); d.open = false; d.dispatchEvent(new Event("close")); };
}
function htmlFila(i) {
var cs = colores.map(function (c) { return '<button type="button" role="radio" class="yj-uni__c' + (colorConStock(c) ? "" : " is-agotado") + '" data-yj-u="' + i + '" data-yj-uc="' + esc(c) + '" aria-checked="false" aria-label="' + esc(c) + '" title="' + esc(c) + '" style="background-image:url(' + esc(tex(c)) + ')"></button>'; }).join("");
var ts = tallas.map(function (t) { return '<button type="button" role="radio" class="yj-uni__tl" data-yj-u="' + i + '" data-yj-ut="' + esc(t) + '" aria-checked="false" aria-label="Talla ' + esc(t) + '">' + esc(t) + "<small>Agotada</small></button>"; }).join("");
return '<div class="yj-uni is-abierta" data-yj-uni="' + i + '"><div class="yj-uni__cab"><p class="yj-uni__t">' + (i ? "<b>Jean " + (i + 1) + "</b>" : '<b class="yj-uni__n1">Tu jean</b><b class="yj-uni__nn">Jean 1</b>')
+ '<span data-yj-uni-sel>elige talla</span></p><div class="yj-uni__cs" role="radiogroup" aria-label="Tono del jean ' + (i + 1) + '">' + cs + "</div></div>"
+ '<div class="yj-uni__ts" role="radiogroup" aria-label="Talla del jean ' + (i + 1) + '">' + ts + "</div></div>";
}
function htmlMedidas() {
var P = CFG.tallasPrenda || {}, ks = Object.keys(P).sort(function (a, b) { return a - b; });
if (!ks.length) return "";
return '<div class="yj-gt" data-yj-gt><p class="yj-dlg__guia"><span>¿No sabes tu talla? La modelo usa la <b>' + esc(CFG.modeloTalla || "6") + '</b>.</span><button type="button" class="yj-campo__link" data-yj-gt-b aria-expanded="false" aria-controls="yj-gt-p">' + ico("metro") + '<span class="yj-gt__ver">Ver medidas</span><span class="yj-gt__ocu">Ocultar</span></button></p>'
+ '<div class="yj-gt__p" id="yj-gt-p"><table class="yj-gt__t"><thead><tr><th scope="col">Talla</th><th scope="col">Cintura</th><th scope="col">Cadera</th><th scope="col">Largo</th></tr></thead><tbody>'
+ ks.map(function (k) { var m = P[k]; return '<tr><th scope="row">' + esc(k) + "</th><td>" + m[0] + " cm</td><td>" + m[1] + " cm</td><td>" + (m[2] / 100).toFixed(2).replace(".", ",") + " m</td></tr>"; }).join("")
+ '</tbody></table><p class="yj-gt__n">Medidas del jean <b>sin estirar</b> (±1 cm). La tela súper licrada se adapta a tu cuerpo. Si no te queda, la cambias sin peros.</p>'
+ '<a class="yj-campo__link yj-gt__bus" href="#yj-tallas">' + ico("metro") + "Calcula tu talla con tus medidas</a></div></div>";
}
function crearDlg() {
if (dlg) return dlg;
var g = REG.filter(function (r) { return r.tallas && r.tallas.length; })[0] || null, unica = !!(g && g.tallas.length === 1);
var pgs = $(".yj-accion [data-yj-pgs]"), htmlPgs = pgs ? pgs.outerHTML.split("yj-pgs--cta").join("yj-pgs--pie") : "";
dlg = document.createElement("dialog");
dlg.className = "yj-dlg yj-dlg--compra"; dlg.setAttribute("data-yj-dlg", ""); dlg.setAttribute("aria-labelledby", "yj-dlg-t"); modalizar(dlg);
dlg.innerHTML = '<div class="yj-dlg__in"><div class="yj-dlg__cab"><h2 id="yj-dlg-t" data-yj-dlg-t>Elige tono y talla</h2><button type="button" class="yj-dlg__x" data-yj-dlg-cerrar aria-label="Cerrar">' + ico("cerrar") + '</button></div>'
+ '<div class="yj-dlg__cuerpo" data-yj-dlg-cuerpo><div class="yj-pc" data-yj-pc>'
+ '<div class="yj-pc__g"><p class="yj-pc__t">¿Cuántos llevas?<span class="yj-reloj yj-reloj--mini" data-yj-reloj data-yj-reloj-mini role="timer">' + ico("reloj") + '<span data-yj-reloj-t></span></span></p><div class="yj-hoja__ns" role="radiogroup" aria-label="Cantidad de jeans">'
+ [1, 2, 3].map(function (k) { return '<button type="button" role="radio" class="yj-hoja__n" data-yj-hn="' + k + '" aria-checked="false"><b>' + k + (k === 1 ? " jean" : " jeans") + '</b><span data-yj-of-total="' + k + '"></span><small data-yj-of-ahorro="' + k + '"></small></button>'; }).join("") + "</div></div>"
+ '<div class="yj-unis" data-yj-unis data-n="1">' + [0, 1, 2].map(htmlFila).join("") + "</div>"
+ htmlMedidas()
+ (g ? '<div class="yj-regt' + (unica ? " yj-regt--unica" : "") + '" data-yj-regt><p class="yj-regt__t">' + (unica ? ico("regalo") : "") + "<b>" + esc(g.linea || "Tu " + (g.prenda || g.nombre).toLowerCase() + " de regalo") + "</b><span data-yj-regt-sel>" + (unica ? "· " + esc(g.tallas[0].toLowerCase()) : "elige su talla") + "</span></p>"
+ (unica ? "" : '<div class="yj-regt__ts" role="radiogroup" aria-label="Talla de la prenda de obsequio">' + g.tallas.map(function (t) { return '<button type="button" role="radio" class="yj-regt__b" data-yj-regt-t="' + esc(t) + '" aria-checked="false">' + esc(t) + "</button>"; }).join("") + "</div>")
+ (g.sinCambio ? '<p class="yj-regt__nota" data-yj-regt-nota>' + ico("info") + "<span>" + esc(g.sinCambio) + "</span></p>" : "") + "</div>" : "")
+ (XT ? '<div class="yj-xt" data-yj-xt><label class="yj-xt__l"><input type="checkbox" class="yj-xt__i" data-yj-xt-c><span class="yj-xt__caja" aria-hidden="true"></span><span class="yj-xt__t"><b>Agrega un ' + esc(XT.nombre || "Top básico") + '</b><span data-yj-xt-p></span></span></label><div class="yj-xt__cs" data-yj-xt-cs role="radiogroup" aria-label="Color del ' + esc((XT.nombre || "top").toLowerCase()) + '"></div></div>' : "")
+ '</div><ul class="yj-dlg__lineas" data-yj-dlg-lineas></ul>'
+ '<fieldset class="yj-dlg__sec yj-ciu yj-ciu--chips"><legend class="yj-pc__t">¿Dónde lo recibes?</legend><div class="yj-ciu__op" data-yj-ciudades role="radiogroup" aria-label="Ciudad de entrega">'
+ Object.keys(CIUS).map(function (k) { return '<button type="button" role="radio" class="yj-ciu__b" data-yj-ciu="' + k + '" aria-checked="' + (tipoCiudad === k) + '">' + CIUS[k] + "</button>"; }).join("")
+ '</div><p class="yj-ciu__nota" data-yj-ciu-nota></p></fieldset></div>'
+ '<div class="yj-dlg__pie"><p class="yj-dlg__err" data-yj-dlg-err role="alert"></p><p class="yj-dlg__tot"><span data-yj-dlg-tot-t>Total · ' + (GRATIS ? "envío gratis" : "+ envío") + '</span><b data-yj-dlg-total></b></p><button type="button" class="yj-cta" data-yj-finalizar><span data-yj-fin-txt>CONFIRMAR PEDIDO</span>' + ico("flecha") + "</button>"
+ (ANT ? '<button type="button" class="yj-ant" data-yj-finalizar-ant><span class="yj-ant__t">PAGAR AHORA <b class="yj-ant__p">−' + ANT.pct + ' %</b></span><small data-yj-ant-det></small></button>' : "")
+ htmlPgs + "</div></div>";
raiz.appendChild(dlg); olvidar();
unisBox = $("[data-yj-unis]", dlg);
filas = $$(".yj-uni", dlg).map(function (el) { return { el: el, sel: $("[data-yj-uni-sel]", el), cs: $$("[data-yj-uc]", el), ts: $$("[data-yj-ut]", el) }; });
var rg = $("[data-yj-regt]", dlg); regt = rg ? { el: rg, sel: $("[data-yj-regt-sel]", rg), nombre: (g.prenda || g.nombre).toLowerCase(), unica: unica } : null;
cada(".yj-cta[data-yj-finalizar]", initCta, dlg);
initXt();
dlg.addEventListener("close", function () {
var au = dlg.getAttribute("data-auto");
if (au === "1" && dlgAbiertoEn && Date.now() - dlgAbiertoEn < 4000) { track("popup_auto_cerrado_rapido"); popAutoFin("cerro_rapido"); guardarSes("yj-popauto", String((PA && PA.segundos || []).length || 2)); }
if (dlgModo === "unidades" && !dlgCompro) track("popup_cerrado_sin_comprar");
dlg.removeAttribute("data-modo"); actualizarBarra();
if (dlgHist && history.state && history.state.yjDlg) { dlgHist = false; history.back(); }
dlgHist = false;
if (dlgOrigen && document.contains(dlgOrigen)) try { dlgOrigen.focus({ preventScroll: true }); } catch (e) {}
});
dlg.addEventListener("click", function (e) { if (e.target === dlg) cerrarRapido(); });
atraparFoco(dlg);
return dlg;
}
function atraparFoco(d) {
d.addEventListener("keydown", function (e) {
if (e.key !== "Tab") return;
var f = $$('button:not([disabled]),[href],input,[tabindex="0"]', d).filter(function (x) { return x.offsetParent !== null && x.tabIndex >= 0; });
if (!f.length) return; var a = f[0], z = f[f.length - 1];
if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
});
}
function hayModal() { return !!((dlg && dlg.open) || (dlgGuia && dlgGuia.open)); }
var PA = CFG.popAuto && CFG.popAuto.activo ? CFG.popAuto : null, paT = [], paFin = !PA;
function popAutoFin(motivo) { if (paFin) return; paFin = true; YJ.popAuto = motivo; paT.forEach(clearTimeout); paT = []; }
function popAutoHechos() { return +(leerSes("yj-popauto") || 0) || 0; }
function pantallaCompleta() { try { if (document.fullscreenElement || document.webkitFullscreenElement) return true; var v = document.querySelectorAll("video"); for (var i = 0; i < v.length; i++) if (v[i].webkitDisplayingFullscreen) return true; } catch (e) {} return false; }
function escribiendo() { var a = document.activeElement; return !!(a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable)); }
function popAutoAbrir(n) {
if (paFin) return;
if (document.hidden) { var alVolver = function () { if (document.hidden) return; document.removeEventListener("visibilitychange", alVolver); paT.push(setTimeout(function () { popAutoAbrir(n); }, 1500)); }; document.addEventListener("visibilitychange", alVolver); return; }
var max = (PA.segundos || []).length || 2;
if (popAutoHechos() >= max) { popAutoFin("tope"); return; }
if (enviando || YJ.ultimaRuta || hayModal() || document.querySelector("dialog[open]") || pantallaCompleta() || escribiendo()) { track("popup_auto_omitido"); return; }
guardarSes("yj-popauto", String(popAutoHechos() + 1));
track("popup_auto_" + n); YJ.popAutoN = n;
abrirDlg("unidades", null, null, true);
if (dlg) dlg.setAttribute("data-auto", String(n));
}
function popAutoArrancar() {
if (paFin) return;
(PA.segundos || [45, 90]).slice(0, 2).forEach(function (s, i) { if (i >= popAutoHechos() && +s > 0) paT.push(setTimeout(function () { popAutoAbrir(i + 1); }, (YJ.popAutoEscala || 1) * s * 1000)); });
}
YJ.popAutoArrancar = function () { paT.forEach(clearTimeout); paT = []; popAutoArrancar(); };
var trasPop = null;
window.addEventListener("popstate", function () {
if (ignorarPop) { ignorarPop = false; if (trasPop) { var f = trasPop; trasPop = null; f(); } return; }
if (dlgGuia && dlgGuia.open) { guiaHist = false; dlgGuia.close(); return; }
if (dlg && dlg.open) { dlgHist = false; dlg.close(); }
});
var dlgAbiertoEn = 0;
function abrirDlg(modo, lineas, origen, auto) {
if (!auto) popAutoFin("abrio_popup");
crearDlg(); dlgModo = modo; dlg.setAttribute("data-modo", modo); dlgCompro = false; if (!auto) dlg.removeAttribute("data-auto");
if (modo === "unidades" && !dlg.open) for (var iu = 1; iu < est.unis.length; iu++) if (!est.unis[iu].t) est.unis[iu].c = u0().c;
var li = $("[data-yj-dlg-lineas]", dlg), err = $("[data-yj-dlg-err]", dlg);
if (err.firstChild) err.textContent = "";
$$(".is-falta", dlg).forEach(function (x) { x.classList.remove("is-falta"); });
txt($("[data-yj-dlg-t]", dlg), modo === "carrito" ? "Tu carrito" : est.n === 1 ? "Elige tu talla" : "Elige tono y talla");
if (modo === "carrito") li.innerHTML = (lineas || []).map(function (x) { return "<li><span>" + esc(x.product_title || x.title) + (x.variant_title ? " · " + esc(x.variant_title) : "") + " × " + x.quantity + "</span><b>" + fmt((x.final_line_price || x.line_price || 0) / 100) + "</b></li>"; }).join("");
txt($("[data-yj-dlg-tot-t]", dlg), modo === "carrito" ? "Total del carrito" : GRATIS ? "Total · envío gratis" : "Total · + envío");
pintarUnis(); pintarPrecios(); pintarCiudad(); pintarReloj(); rovingTodo(); pintarAnt();
if (modo === "carrito") { var tot = (lineas || []).reduce(function (a, x) { return a + (x.final_line_price || x.line_price || 0); }, 0); $("[data-yj-dlg-total]", dlg).textContent = fmt(tot / 100); }
if (!dlg.open) {
dlgOrigen = origen || document.activeElement;
try { dlg.showModal(); } catch (e) { dlg.setAttribute("open", ""); }
dlgAbiertoEn = Date.now();
try { history.pushState({ yjDlg: 1 }, ""); dlgHist = true; } catch (e) {}
var cu = $("[data-yj-dlg-cuerpo]", dlg); if (cu) cu.scrollTop = 0;
track("popup_abierto"); if (modo === "unidades") { track("popup_compra_abierto"); track(est.n > 1 ? "popup_tallas_abierto" : "hoja_rapida_abierta"); } actualizarBarra();
}
}
function cerrarDlg(sinHistoria) { if (!dlg || !dlg.open) return; if (sinHistoria) dlgHist = false; dlg.classList.remove("is-cerrando"); dlg.close(); }
function cerrarRapido() {
if (!dlg || !dlg.open || dlg.classList.contains("is-cerrando")) return;
dlg.classList.add("is-cerrando");
luego("cerrar", function () { if (dlg.classList.contains("is-cerrando")) { dlg.classList.remove("is-cerrando"); if (dlg.open) dlg.close(); } });
}
YJ.cerrarRapido = cerrarRapido;
YJ.abrirDlg = abrirDlg; YJ.cerrarDlg = cerrarDlg;
function validarDlg() {
var err = $("[data-yj-dlg-err]", dlg), msg = "", faltan = [], primero = null; errTok++;
if (dlgModo === "unidades") {
for (var i = 0; i < est.n; i++) {
var u = est.unis[i], mal = !u.t || !hayStock(u.c, u.t);
if (mal) { u.t = null; faltan.push(est.n === 1 ? "de tu jean" : "del jean " + (i + 1)); primero = primero || filas[i].el; }
}
var g = regaloPrenda(est.n), sinReg = !!(g && regt && !regt.unica && !est.regaloTalla);
if (sinReg) { faltan.push("de tu " + regt.nombre + " de regalo"); primero = primero || regt.el; }
pintarUnis();
for (i = 0; i < est.n; i++) filas[i].el.classList.toggle("is-falta", !est.unis[i].t);
if (regt) regt.el.classList.toggle("is-falta", sinReg);
if (faltan.length) msg = "Te falta elegir la talla " + (faltan.length > 1 ? faltan.slice(0, -1).join(", ") + " y " + faltan[faltan.length - 1] : faltan[0]) + ", mi reina.";
if (primero) try { primero.scrollIntoView({ behavior: comp, block: "center" }); } catch (e) {}
}
if (!msg && !tipoCiudad) { msg = "Elige dónde lo recibes: Bogotá, Soacha u otra ciudad."; var c = $(".yj-ciu", dlg); if (c) { reanimar(c, "is-falta"); } }
err.textContent = msg;
return !msg;
}
function alFinalizarDlg(btn, anticipado) {
if (dlgModo === "unidades") track("popup_comprar");
if (!validarDlg()) return;
anticipado = !!(anticipado && hayAnticipado() && dlgModo !== "carrito");
track("popup_completo");
if (anticipado) track("popup_pagar_anticipado"); else if (esContraEntrega() && dlgModo !== "carrito") track("popup_pagar_contraentrega");
finalizar(btn, dlgModo !== "carrito", anticipado);
}
function abrirCarrito() {
if (TIENDA.carrito === "pagina") {
var ir = function () { YJ.ultimaRuta = "carrito"; location.href = RAIZ_TIENDA + "cart"; };
refrescarCarrito().then(function (c) { if (c && c.item_count) ir(); else aviso("Tu carrito está vacío, mi reina. Elige tu Lipo Jean ✨"); }, ir);
return;
}
if (!carritoN) { aviso("Tu carrito está vacío, mi reina. Elige tu Lipo Jean ✨"); return; }
refrescarCarrito().then(function (c) { if (!c.item_count) { aviso("Tu carrito está vacío, mi reina. Elige tu Lipo Jean ✨"); return; } abrirDlg("carrito", c.items, $("[data-yj-carrito]")); }, function () { aviso("No pudimos abrir tu carrito. Intenta de nuevo."); });
}
function alScroll(fn) { document.addEventListener("scroll", fn, { passive: true, capture: true }); }
var actualizarBarra = function () {};
var barraToco = false, tocoSelector = function () {}, trasTalla = function () {};
function initBarra() {
var barra = $("[data-yj-barra]"), ancla = ctaMain; if (!barra || !ancla) return;
var antes = null, altoB = 0, finEl = null, btnB = $("[data-yj-comprar]", barra);
function medir() {
var h = innerHeight, r0 = ancla.getBoundingClientRect(), rr = raiz.getBoundingClientRect();
if (!altoB && antes) altoB = barra.offsetHeight + 8;
var main = r0.bottom > 0 && r0.top < h - (antes ? altoB : 0), on = !main && (barraToco || -rr.top > h * 0.5);
if (on) { finEl = finEl || document.getElementById("yj-cierre"); if (finEl) { var r = finEl.getBoundingClientRect(); if (r.top < h && r.bottom > 0) on = false; } }
if (hayModal()) on = false;
return { on: on, r0: r0, h: h };
}
function poner(on) {
if (on === antes) return false; antes = on;
barra.classList.toggle("is-on", on); barra.setAttribute("aria-hidden", on ? "false" : "true");
if (on) { barra.removeAttribute("inert"); if (prog) prog(); } else barra.setAttribute("inert", "");
return true;
}
var revisar = porFrame(function () { poner(medir().on); });
actualizarBarra = revisar;
tocoSelector = function () { barraToco = true; poner(medir().on); };
trasTalla = function () {
barraToco = true;
var m = medir(), cerca = m.r0.top >= 0 && m.r0.top < m.h * 1.6;
if (cerca) { avisarCta(null); poner(medir().on); return; }
poner(m.on); if (antes && btnB) rebotar(btnB);
};
alScroll(revisar); window.addEventListener("resize", revisar); revisar();
var animsP = null;
var prog = porFrame(function () {
if (!antes) return;
if (!animsP) { animsP = []; $$(".yj-barra__prog i, .yj-barra__cor", barra).forEach(function (e) { if (e.getAnimations) e.getAnimations().forEach(function (a) { try { a.pause(); animsP.push(a); } catch (x) {} }); }); }
if (!animsP.length) return;
var r = raiz.getBoundingClientRect(), p = Math.max(0, Math.min(1, -r.top / Math.max(1, r.height - innerHeight)));
animsP.forEach(function (a) { try { a.currentTime = p * 1000; } catch (x) {} });
YJ.progreso = p;
});
alScroll(prog);
}
function saludar() {
var h = new Date().getHours(), s = h >= 5 && h < 12 ? "Buenos días" : h >= 12 && h < 19 ? "Buenas tardes" : "Buenas noches";
$$("[data-yj-saludo]").forEach(function (e) { if (e.firstChild && e.firstChild.nodeType === 3) e.firstChild.nodeValue = s + ", mi reina "; });
}
var ojo = hayIO && !reducido ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-visto"); ojo.unobserve(e.target); } }); }, { rootMargin: "0px 0px -10% 0px" }) : null;
function initVer(e) { if (ojo) ojo.observe(e); else e.classList.add("is-visto"); }
var ojoCta = hayIO && !reducido ? new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle("is-vista", e.isIntersecting); }); }) : null;
function initCta(e) { if (ojoCta) ojoCta.observe(e); }
function estrellas(v) {
var s = "", i; for (i = 0; i < 5; i++) s += '<svg viewBox="0 0 24 24" aria-hidden="true"><use href="#yj-g-estrella"></use></svg>';
return '<span style="display:inline-flex;color:#e8dde1">' + s + '</span><span style="position:absolute;left:0;top:0;bottom:0;display:inline-flex;overflow:hidden;color:var(--yj-rosa);width:' + Math.max(0, Math.min(100, v / 5 * 100)).toFixed(1) + '%">' + s + "</span>";
}
function coma(v) { return String(v).replace(".", ","); }
function pintarRatings() {
var R = TIENDA.rating || {}, rt = R.tienda, a = $("[data-yj-rating]");
if (a) { if (!rt || !rt.cantidad) a.hidden = true; else { var s = $("[data-yj-rating-s]", a); s.innerHTML = estrellas(rt.valor); s.style.position = "relative"; $("[data-yj-rating-v]", a).textContent = coma(rt.valor); $("[data-yj-rating-n]", a).textContent = "· " + rt.cantidad + " reseñas"; a.setAttribute("aria-label", coma(rt.valor) + " de 5 estrellas: " + rt.cantidad + " reseñas de la tienda Yass. Ver reseñas"); } }
$$("[data-yj-estrellas]:not([data-ok])").forEach(function (e) { e.setAttribute("data-ok", ""); if (rt) { e.style.position = "relative"; e.innerHTML = estrellas(rt.valor); } });
if (rt) { $$("[data-yj-r-tienda-v]").forEach(function (e) { e.textContent = coma(rt.valor); }); $$("[data-yj-r-tienda-n]").forEach(function (e) { e.textContent = rt.cantidad; }); }
}
function abrirAcc(b, si) {
var r = document.getElementById(b.getAttribute("aria-controls")); if (!r) return;
b.setAttribute("aria-expanded", si ? "true" : "false");
if (si) r.removeAttribute("hidden"); else r.setAttribute("hidden", "until-found");
$$("[data-yj-loop-acc]", r).forEach(function (l) {
if (si) {
var p = $("img[data-yj-src]", l); if (p) { p.src = p.getAttribute("data-yj-src").replace(/^assets\//, BASE); p.removeAttribute("data-yj-src"); }
if (vivos && !reducido && !l.__yjObs) { l.__yjObs = 1; vivos.observe(l); }
} else pausar(l);
});
}
function initAcc(box) {
$$("[aria-controls]", box).forEach(function (b) {
var r = document.getElementById(b.getAttribute("aria-controls"));
if (r) r.addEventListener("beforematch", function () { abrirAcc(b, true); });
});
}
function resolverFotos(base) {
$$("img[data-yj-foto-k], img[data-yj-foto-color]", base).forEach(function (im) {
var k = (CFG.fotosSecciones || {})[im.getAttribute("data-yj-foto-k")], c = im.getAttribute("data-yj-foto-color"), fn = +im.getAttribute("data-yj-foto-n") || 0;
var fc = c ? fotosDe(c) : [], f = k ? fotoPorId[k.id] || fotosDe(k.color || colores[0])[k.n || 0] : c ? fc[fn] || fc[0] : null;
f = f || FOTOS[0]; if (!f) return;
im.setAttribute("srcset", srcset(f)); im.setAttribute("sizes", im.getAttribute("data-yj-sizes") || "100vw"); im.src = url(f, 720);
im.width = f.w; im.height = f.h; im.removeAttribute("data-yj-foto-k"); im.removeAttribute("data-yj-foto-color"); im.removeAttribute("data-yj-foto-n");
});
}
function initCarr(c) {
var p = $("[data-yj-carr-pista]", c), sel = c.getAttribute("data-yj-items"), libre = c.hasAttribute("data-yj-libre"), items = sel ? $$(sel, p) : Array.prototype.slice.call(p.children), box = $("[data-yj-puntos]", c), centrado = c.hasAttribute("data-yj-centrado") || c.hasAttribute("data-yj-snap-centro"), arrancaEn1 = c.hasAttribute("data-yj-centrado");
if (sel) items.sort(function (a, b) { return a.offsetLeft - b.offsetLeft; });
var cont = $("[data-yj-contador]", c);
if (!sel) items = items.filter(function (it) { return !it.hidden; });
if (box) box.innerHTML = items.map(function () { return "<i></i>"; }).join("");
var pts = box ? $$("i", box) : [], pr = $("[data-yj-prev]", c), nx = $("[data-yj-next]", c), act = -1;
function pintarCont() { if (cont) cont.textContent = (Math.max(0, act) + 1) + " / " + items.length; }
c.__refrescar = function () { items = Array.prototype.slice.call(p.children).filter(function (it) { return !it.hidden; }); act = -1; marcar(); };
function actual() { if (!arrancaEn1) { if (p.scrollLeft <= 2) return 0; if (p.scrollLeft >= p.scrollWidth - p.clientWidth - 2) return items.length - 1; } var cx = p.scrollLeft + (centrado ? p.clientWidth / 2 : 0), m = 0, d = 1e9; items.forEach(function (it, k) { var x = it.offsetLeft - p.offsetLeft + (centrado ? it.offsetWidth / 2 : 0), dd = Math.abs(x - cx - (centrado ? 0 : 16)); if (dd < d) { d = dd; m = k; } }); return m; }
function marcar() { var i = actual(); if (i === act) return; act = i; pintarCont(); pts.forEach(function (x, k) { x.classList.toggle("is-act", k === i); }); if (pr) pr.disabled = i === 0; if (nx) nx.disabled = i === items.length - 1; items.forEach(function (it, k) { it.classList.toggle("is-act", k === i); if (k !== i && !libre) pausar(it); }); }
function ir(i) { i = Math.max(0, Math.min(items.length - 1, i)); var it = items[i]; p.scrollTo({ left: it.offsetLeft - p.offsetLeft - (centrado ? (p.clientWidth - it.offsetWidth) / 2 : 16), behavior: comp }); }
p.addEventListener("scroll", porFrame(marcar), { passive: true });
var a0 = 0; p.addEventListener("pointerdown", function () { a0 = act; });
arrastrar(p, function (dx) { var i = actual(); if (i === a0 && Math.abs(dx) > 40) i += dx < 0 ? 1 : -1; ir(i); });
if (pr) pr.addEventListener("click", function () { ir(act - 1); });
if (nx) nx.addEventListener("click", function () { ir(act + 1); });
c.__irA = function (el) { ir(items.indexOf(el)); };
if (arrancaEn1 && items.length > 2) { requestAnimationFrame(function () { var it = items[1]; p.scrollLeft = it.offsetLeft - p.offsetLeft - (p.clientWidth - it.offsetWidth) / 2; marcar(); }); } else marcar();
}
function pausar(v) { var vid = v.querySelector && v.querySelector("video"); if (vid && !vid.paused) { try { vid.pause(); } catch (e) {} } }
function srcVideo(id) {
var l = (CFG.videos || []).concat([CFG.videoFabrica, CFG.videoHistoria, CFG.videoTiendas]).filter(Boolean);
for (var i = 0; i < l.length; i++) if (l[i].id === id && l[i].src) return l[i].src;
var m = window.YJ_VIDEOS_MAP || {}, f = "yj-reel-" + id + ".mp4";
return m[f] || m[id] || (window.YJ_VIDEOS ? window.YJ_VIDEOS + f : null);
}
var vigiaVid = hayIO ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.intersectionRatio < 0.35) pausar(e.target); }); }, { threshold: [0, 0.35] }) : null;
var lejosVid = hayIO ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) liberar(e.target); }); }, { rootMargin: "1500px 0px" }) : null;
function liberar(v) {
var vid = v.querySelector("video"); if (!vid) return;
try { vid.pause(); vid.removeAttribute("src"); vid.load(); } catch (e) {}
vid.parentNode.removeChild(vid); v.classList.remove("is-sonando", "is-lista");
if (vigiaVid) vigiaVid.unobserve(v); if (lejosVid) lejosVid.unobserve(v);
}
document.addEventListener("visibilitychange", function () { if (document.hidden) $$(".yj-vid, .yj-loop").forEach(pausar); else refrescarCarrito().catch(function () {}); });
function reproducir(v) {
var carr = v.closest("[data-yj-centrado]");
if (carr && !v.classList.contains("is-act") && carr.__irA) { carr.__irA(v); return; }
var vid = v.querySelector("video");
if (vid && !vid.paused) { vid.pause(); return; }
$$(".yj-vid").forEach(function (o) { if (o !== v) pausar(o); });
if (!vid) {
var s = srcVideo(v.getAttribute("data-yj-vid"));
if (!s) { aviso("Este video estará disponible muy pronto 💗"); return; }
vid = document.createElement("video");
vid.playsInline = true; vid.setAttribute("playsinline", ""); vid.preload = "auto"; vid.controls = false;
var po = v.querySelector(".yj-vid__poster"); if (po) vid.poster = po.currentSrc || po.src;
vid.addEventListener("playing", function () { v.classList.add("is-sonando", "is-lista"); });
vid.addEventListener("pause", function () { v.classList.remove("is-sonando"); });
vid.addEventListener("ended", function () { v.classList.remove("is-sonando"); vid.currentTime = 0; });
vid.src = s;
v.insertBefore(vid, v.firstChild);
if (vigiaVid) vigiaVid.observe(v); if (lejosVid) lejosVid.observe(v);
}
track("video_play");
var pr = vid.play(); if (pr && pr.catch) pr.catch(function () { vid.muted = true; vid.play().catch(function () {}); });
}
YJ.reproducir = reproducir;
var vivos = hayIO ? new IntersectionObserver(function (es) { es.forEach(function (e) { var b = e.target, v = b.querySelector("video");
if (e.isIntersecting) {
if (document.hidden) return;
if (!v) { v = document.createElement("video"); v.muted = true; v.defaultMuted = true; v.setAttribute("muted", ""); v.loop = true; v.playsInline = true; v.setAttribute("playsinline", ""); v.setAttribute("aria-hidden", "true"); v.preload = "auto";
v.addEventListener("playing", function () { b.classList.add("is-on"); }); v.src = archivo(b.getAttribute("data-yj-loop")); b.appendChild(v); }
var p = v.play(); if (p && p.catch) p.catch(function () {});
} else if (v && !v.paused) v.pause();
}); }, { rootMargin: "100px 0px" }) : null;
function archivo(n) { var m = window.YJ_VIDEOS_MAP || {}; return m[n] || (window.YJ_VIDEOS ? window.YJ_VIDEOS + n : BASE + n); }
function initLoop(b) { if (b.hasAttribute("data-yj-loop-acc")) return; if (vivos && !reducido) vivos.observe(b); }
function initBuscador(f) {
var modo = "medidas", C = CFG.tallasCuerpo || {}, W = CFG.tallasPeso || {}, reco = null;
var orden = Object.keys(C).sort(function (a, b) { return a - b; });
$$("[data-yj-bus-modo]", f).forEach(function (b) { b.addEventListener("click", function () {
modo = b.getAttribute("data-yj-bus-modo");
$$("[data-yj-bus-modo]", f).forEach(function (x) { x.setAttribute("aria-selected", x === b ? "true" : "false"); });
$$("[data-yj-bus-campos]", f).forEach(function (x) { x.hidden = x.getAttribute("data-yj-bus-campos") !== modo; });
}); });
function porMedida(v, i0, i1, holgura) {
if (!v) return -1;
for (var k = 0; k < orden.length; k++) { var r = C[orden[k]]; if (v <= r[i1]) return v < r[i0] && k > 0 && holgura ? k : v < r[i0] && k > 0 ? k - 1 : k; }
return orden.length - 1;
}
function irArriba(t, c) {
var enGuia = dlgGuia && dlgGuia.contains(f), uni = enGuia ? guiaUni : null;
var conHist = !!(enGuia && guiaHist); if (enGuia) cerrarGuia();
if (uni != null && dlg && dlg.open) { if (c && c !== est.unis[uni].c) elegirColor(c, uni, true, "popup"); if (t) elegirTalla(t, uni, true); var fila = $('[data-yj-uni="' + uni + '"]', dlg); if (fila) fila.scrollIntoView({ behavior: comp, block: "nearest" }); track("guia_talla_elegida"); return; }
if (c && c !== u0().c) elegirColor(c, 0); if (t) { elegirTalla(t, 0); track("guia_talla_elegida"); }
var volver = function () { var a = campoTalla || $("#yj-compra"); if (!a) return; try { a.scrollIntoView({ behavior: comp, block: "center" }); } catch (e2) { a.scrollIntoView(); } if (t && boxTallas && !reducido) reanimar(boxTallas, "is-marcada"); };
if (conHist) { trasPop = volver; setTimeout(function () { if (trasPop === volver) { trasPop = null; volver(); } }, 600); } else volver();
}
f.addEventListener("submit", function (e) {
e.preventDefault(); track("guia_buscador");
var hol =(f.querySelector("input[name=yj-aj]:checked") || {}).value === "comodo", idx = -1, nota = "";
if (modo === "medidas") {
var ci = +$("[data-yj-bus-cintura]", f).value, ca = +$("[data-yj-bus-cadera]", f).value;
if (!ci && !ca) { aviso("Escribe tu cintura o tu cadera en centímetros."); return; }
idx = Math.max(porMedida(ci, 0, 1, hol), porMedida(ca, 2, 3, hol));
nota = "Según tu " + (ci && ca ? "cintura y cadera" : ci ? "cintura" : "cadera") + (hol ? ", para un ajuste cómodo." : ", para un ajuste moldeador.");
} else {
var pe = +$("[data-yj-bus-peso]", f).value, es = +$("[data-yj-bus-estatura]", f).value;
if (!pe) { aviso("Escribe tu peso en kilos."); return; }
var lim = Object.keys(W).sort(function (a, b) { return a - b; });
idx = lim.length - 1; for (var k = 0; k < lim.length; k++) if (pe <= W[lim[k]]) { idx = k; break; }
if (hol && W[lim[idx]] - pe < 2 && idx < lim.length - 1) idx++;
if (es && es >= 172 && idx < lim.length - 1 && W[lim[idx]] - pe < 3) idx++;
idx = orden.indexOf(lim[idx]);
nota = "Estimada con tu peso" + (es ? " y estatura" : "") + ". Con tus medidas es más precisa.";
}
reco = orden[Math.max(0, idx)];
var mx = C[orden[orden.length - 1]] || [], mn = C[orden[0]] || [], lp = Object.keys(W).sort(function (a, b) { return a - b; });
var fuera = modo === "medidas" ? (ci > mx[1] + 2 || ca > mx[3] + 2) : pe > W[lp[lp.length - 1]] + 3, res = $("[data-yj-bus-res]", f), bt = $("[data-yj-bus-elegir]", f);
var debajo = !fuera && (modo === "medidas" ? idx <= 0 && (!ci || ci < mn[0]) && (!ca || ca < mn[2]) : W[4] != null && pe <= W[4]);
res.classList.toggle("is-fuera", !!fuera);
if (debajo) {
var pref = hol ? "6" : "4", otra = hol ? "4" : "6", c0 = u0().c, tPref = hayStock(c0, pref) ? pref : hayStock(c0, otra) ? otra : null;
$("[data-yj-bus-talla]", f).textContent = "4·6";
$("[data-yj-bus-titulo]", f).textContent = "Te sugerimos talla 4 o 6";
$("[data-yj-bus-det]", f).textContent = "Tus medidas quedan por debajo de la talla 6, la más pequeña de nuestra guía. Elige la 4 si te gusta bien ajustado o la 6 si lo prefieres más cómodo. Si no te queda, la cambias sin peros.";
bt.textContent = tPref ? "Elegir talla " + tPref : "Ver tallas disponibles";
bt.onclick = function () { irArriba(tPref); };
$$("[data-yj-tabla] tr[data-t]").forEach(function (tr) { tr.classList.toggle("is-reco", tr.getAttribute("data-t") === "6"); });
res.hidden = false; return;
}
if (fuera) {
var mayor = orden[orden.length - 1];
$("[data-yj-bus-talla]", f).textContent = mayor;
$("[data-yj-bus-titulo]", f).textContent = "Queremos que te quede perfecto, mi reina";
$("[data-yj-bus-det]", f).textContent = "Tus medidas pasan nuestra guía (hasta talla " + mayor + "). Nuestra talla más grande es la " + mayor + ": si no te queda, te la cambiamos sin peros.";
bt.textContent = "Ver talla " + mayor; bt.onclick = function () { irArriba(hayStock(u0().c, mayor) ? mayor : null); };
res.hidden = false; return;
}
var c = u0().c, ok = hayStock(c, reco), otros = colores.filter(function (x) { return x !== c && hayStock(x, reco); });
$("[data-yj-bus-talla]", f).textContent = reco;
$("[data-yj-bus-titulo]", f).textContent = "Tu talla sugerida es " + reco;
$("[data-yj-bus-det]", f).innerHTML = esc(nota) + " " + (ok ? "<b>Disponible en " + esc(c) + ".</b>" : "Agotada en " + esc(c) + (otros.length ? "; la tienes en " + esc(otros.join(", ")) + "." : " y en los demás tonos por ahora."));
bt.textContent = ok ? "Elegir talla " + reco : otros.length ? "Ver en " + otros[0] : "Ver tallas disponibles";
bt.onclick = function () { if (ok) irArriba(reco); else if (otros.length) irArriba(reco, otros[0]); else irArriba(null); };
res.hidden = false;
$$("[data-yj-tabla] tr[data-t]").forEach(function (tr) { tr.classList.toggle("is-reco", tr.getAttribute("data-t") === reco); });
});
}
function initLook(box) {
var cards = $$("[data-yj-xs]", box), pend = cards.length, vivosXs = 0;
function fin(ok) { if (ok) vivosXs++; if (--pend === 0 && !vivosXs) { var s = box.closest("section"); if (s) s.hidden = true; } }
if (!cards.length) { var s0 = box.closest("section"); if (s0) s0.hidden = true; }
cards.forEach(function (card) {
var h = card.getAttribute("data-yj-xs");
fetch(RAIZ_TIENDA + "products/" + h + ".js").then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
var vs = (p.variants || []).filter(function (v) { return v.available; });
if (!vs.length || (p.options || []).length !== 1) { card.hidden = true; fin(false); return; }
var nom = card.getAttribute("data-yj-xs-nombre") || String(p.title).replace(/^\s*\d+\.\s*/, "");
var img = p.featured_image || (p.images || [])[0] || "", src = img ? (String(img).indexOf("?") > -1 ? img + "&width=400" : img + "?width=400") : "";
var fx = card.getAttribute("data-yj-xs-foto"), fo = fx ? FOTOS.filter(function (f) { return String(f.u).indexOf(fx) > -1; })[0] : null;
if (fo) src = url(fo, 400);
$(".yj-xs__foto", card).innerHTML = src ? '<img src="' + esc(src) + '" width="400" height="500" alt="' + esc(nom) + ' de Yass Moda" loading="lazy" decoding="async">' : "";
$(".yj-xs__n", card).textContent = nom;
$(".yj-xs__p", card).textContent = fmt(p.price / 100);
var chips = $(".yj-xs__chips", card), elegido = vs[0], bt = $(".yj-cta2", card);
chips.innerHTML = vs.slice(0, 6).map(function (v, i) { return '<button type="button" data-id="' + v.id + '" aria-pressed="' + (i === 0) + '">' + esc(v.title) + "</button>"; }).join("");
chips.addEventListener("click", function (e) { var b = e.target.closest("button"); if (!b) return; $$("button", chips).forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); }); elegido = vs.filter(function (v) { return String(v.id) === b.getAttribute("data-id"); })[0]; });
bt.textContent = "Agregar al carrito";
bt.onclick = function () { bt.setAttribute("aria-busy", "true"); pedir("cart/add.js", { items: [{ id: elegido.id, quantity: 1 }] }).then(function () { bt.removeAttribute("aria-busy"); refrescarCarrito().catch(function () {}); aviso("¡Agregado a tu carrito! " + esc(p.title.replace(/^\s*\d+\.\s*/, "")) + " · " + esc(elegido.title) + ". Lo pagas junto con tu Lipo Jean.", 4500); }).catch(function () { bt.removeAttribute("aria-busy"); aviso("No pudimos agregarlo. Intenta de nuevo."); }); };
card.classList.remove("is-cargando"); fin(true);
}).catch(function () { card.hidden = true; fin(false); });
});
}
function initResenas(sec) {
var b = $("[data-yj-res-mas]", sec), carr = $("[data-yj-res-carr]", sec), liMas = $("[data-yj-res-mas-li]", sec);
function ocultas() { return $$("[data-yj-res-l] > li[hidden]:not([data-yj-res-mas-li])", sec); }
function leer(base) {
$$("[data-yj-res-l] > li:not([hidden]):not([data-yj-res-mas-li])", base || sec).forEach(function (li) {
if (li.__yjLeer) return; var q = $("q", li); if (!q || q.scrollHeight <= q.clientHeight + 2) return; li.__yjLeer = 1;
var bt = document.createElement("button"); bt.type = "button"; bt.className = "yj-res__leer"; bt.textContent = "Leer completa"; bt.setAttribute("aria-expanded", "false");
bt.addEventListener("click", function () { var si = !li.classList.contains("is-abierta"); li.classList.toggle("is-abierta", si); bt.textContent = si ? "Leer menos" : "Leer completa"; bt.setAttribute("aria-expanded", si ? "true" : "false"); });
q.parentNode.insertBefore(bt, q.nextSibling);
});
}
function pintar() { var q = ocultas().length; if (liMas) liMas.hidden = !q; if (b) { var n = $("[data-yj-res-quedan]", b); if (n) n.textContent = q; } }
if (b) b.addEventListener("click", function () {
var nuevas = ocultas().slice(0, 12); nuevas.forEach(function (li) { li.hidden = false; }); pintar(); leer();
if (carr && carr.__refrescar) { carr.__refrescar(); if (nuevas[0] && carr.__irA) carr.__irA(nuevas[0]); }
if (nuevas[0]) { var f = nuevas[0].querySelector("q"); if (f) { nuevas[0].setAttribute("tabindex", "-1"); try { nuevas[0].focus({ preventScroll: true }); } catch (e) {} } }
track("resenas_ver_mas");
});
pintar(); if (carr && carr.__refrescar) carr.__refrescar();
requestAnimationFrame(function () { leer(); });
if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { leer(); });
}
function abrirPolitica(a) {
cssSecciones();
var href = a.getAttribute("href"), d = document.createElement("dialog");
d.className = "yj-dlg yj-dlg-pol"; d.setAttribute("aria-label", a.textContent);
d.innerHTML = '<div class="yj-dlg__in"><div class="yj-dlg__cab"><h2>' + esc(a.textContent) + '</h2><button type="button" class="yj-dlg__x" aria-label="Cerrar">' + ico("cerrar") + '</button></div><div class="yj-dlg__cuerpo"><p>Cargando…</p></div></div>';
raiz.appendChild(d);
$(".yj-dlg__x", d).addEventListener("click", function () { d.close(); });
d.addEventListener("click", function (e) { if (e.target === d) d.close(); });
d.addEventListener("close", function () { if (d.parentNode) d.parentNode.removeChild(d); });
try { d.showModal(); } catch (e) { location.href = href; return; }
fetch(href, { credentials: "same-origin" }).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (h) {
var doc = new DOMParser().parseFromString(h, "text/html"), c = doc.querySelector(".shopify-policy__body, .shopify-policy__container, main") || doc.body;
$$("script,style,iframe,form,link,meta,noscript", c).forEach(function (x) { x.parentNode.removeChild(x); });
$$("*", c).forEach(function (x) { Array.prototype.slice.call(x.attributes).forEach(function (at) { if (/^on/i.test(at.name) || (/^(href|src)$/i.test(at.name) && /^\s*javascript:/i.test(at.value))) x.removeAttribute(at.name); }); });
$$("a[href]", c).forEach(function (x) { var s = document.createElement("span"); s.innerHTML = x.innerHTML; x.parentNode.replaceChild(s, x); });
$(".yj-dlg__cuerpo", d).innerHTML = c.innerHTML.trim() || "<p>Esta política aún no está publicada.</p>";
}).catch(function () { d.close(); location.href = href; });
}
var guiaSrc = raiz.getAttribute("data-yj-guia-src"), guiaP = null, dlgGuia = null, guiaHist = false, guiaOrigen = null, guiaUni = null, ignorarPop = false;
function traerGuia() {
if (!guiaSrc) return Promise.reject(new Error("sin guía"));
if (!guiaP) guiaP = fetch(guiaSrc).then(function (x) { if (!x.ok) throw new Error(x.status); return x.json(); }).then(function (j) {
var t = document.createElement("template"); t.innerHTML = String(j.html).replace(/(^|[\s"'(,])assets\/(?=yj-)/g, "$1" + BASE); return t;
}).catch(function (e) { guiaP = null; throw e; });
return guiaP;
}
YJ.traerGuia = traerGuia;
function crearGuia() {
cssSecciones();
if (dlgGuia) return dlgGuia;
var d = dlgGuia = document.createElement("dialog");
d.className = "yj-dlg yj-dlg-guia"; d.setAttribute("data-yj-guia-dlg", ""); d.setAttribute("aria-labelledby", "yj-guia-t"); modalizar(d);
d.innerHTML = '<div class="yj-dlg__in"><div class="yj-dlg__cab"><h2 id="yj-guia-t">Encuentra tu talla</h2><button type="button" class="yj-dlg__x" data-yj-guia-cerrar aria-label="Cerrar la guía de tallas">' + ico("cerrar") + '</button></div><div class="yj-dlg__cuerpo" data-yj-guia-cuerpo><p>Cargando la guía de tallas…</p></div></div>';
raiz.appendChild(d); olvidar();
$("[data-yj-guia-cerrar]", d).addEventListener("click", function () { d.close(); });
d.addEventListener("click", function (e) { if (e.target === d) d.close(); });
d.addEventListener("close", function () {
actualizarBarra();
if (guiaHist && history.state && history.state.yjGuia) { guiaHist = false; ignorarPop = true; history.back(); }
guiaHist = false;
if (guiaOrigen && document.contains(guiaOrigen)) try { guiaOrigen.focus({ preventScroll: true }); } catch (e) {}
});
atraparFoco(d);
return d;
}
function abrirGuia(origen, uni) {
cssSecciones();
crearGuia(); guiaOrigen = origen || document.activeElement; guiaUni = uni == null ? null : uni;
if (!dlgGuia.open) {
try { dlgGuia.showModal(); } catch (e) { dlgGuia.setAttribute("open", ""); }
try { history.pushState({ yjGuia: 1 }, ""); guiaHist = true; } catch (e) {}
track("guia_abierta"); actualizarBarra();
}
var cuerpo = $("[data-yj-guia-cuerpo]", dlgGuia);
if (cuerpo.__yjOk) return Promise.resolve();
return traerGuia().then(function (t) {
if (cuerpo.__yjOk) return; cuerpo.__yjOk = 1;
resolverFotos(t.content); cuerpo.innerHTML = ""; cuerpo.appendChild(t.content.cloneNode(true)); initLote(cuerpo);
cuerpo.scrollTop = 0;
}, function () { cuerpo.innerHTML = "<p>No pudimos abrir la guía de tallas. Revisa tu conexión e intenta de nuevo.</p>"; });
}
function cerrarGuia() { if (dlgGuia && dlgGuia.open) dlgGuia.close(); }
YJ.abrirGuia = abrirGuia; YJ.cerrarGuia = cerrarGuia;
["pointerenter", "touchstart", "focusin"].forEach(function (ev) {
raiz.addEventListener(ev, function (e) { var t = e.target; if (t && t.closest && t.closest('a[href="#yj-tallas"]')) traerGuia().catch(function () {}); }, { passive: true, capture: true });
});
var mvCargado = false;
function arEstado(ua, toques, plataforma, puede, usdz) {
var ios = /iPhone|iPad|iPod/.test(ua) || (toques > 1 && /Mac/.test(plataforma || "")), movil = ios || /Android/i.test(ua);
return !movil ? "no" : puede && (!ios || usdz) ? "si" : "nada";
}
YJ.arEstado = arEstado;
function init3d(sec) {
if (!CFG.glb) { sec.hidden = true; return; }
var nav = navigator, mvAr = null, arBtn = $("[data-yj-3d-ar]", sec);
function arPintar() {
var e = arEstado(nav.userAgent, nav.maxTouchPoints || 0, nav.platform, !!(mvAr && mvAr.canActivateAR), CFG.usdz);
sec.classList.toggle("is-ar-si", e === "si"); sec.classList.toggle("is-ar-no", e === "no"); sec.classList.toggle("is-ar-nada", e === "nada" && !!mvAr);
return e;
}
arPintar(); YJ.arPintar = arPintar;
if (arBtn) arBtn.addEventListener("click", function () { track("ar_abrir"); try { if (mvAr && mvAr.canActivateAR) mvAr.activateAR(); } catch (e) {} });
function montar() {
if (!mvCargado) { mvCargado = true; self.ModelViewerElement = self.ModelViewerElement || {}; self.ModelViewerElement.meshoptDecoderLocation = "https://cdn.jsdelivr.net/npm/meshoptimizer@0.21.0/meshopt_decoder.js"; var s = document.createElement("script"); s.type = "module"; s.src = "https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js"; document.head.appendChild(s); }
var caja = $("[data-yj-3d-caja]", sec);
var glb = /^(https?:)?\/\//.test(CFG.glb) ? CFG.glb : (window.YJ_VIDEOS_MAP || {})[CFG.glb] || BASE + CFG.glb;
caja.insertAdjacentHTML("beforeend", '<model-viewer src="' + esc(glb) + '"' + (CFG.usdz ? ' ios-src="' + esc(CFG.usdz) + '"' : "") + ' alt="Lipo Jean de Yass Moda en 3D" camera-controls touch-action="pan-y" auto-rotate auto-rotate-delay="1200" rotation-per-second="18deg" interaction-prompt="none" environment-image="neutral" tone-mapping="neutral" exposure="1.08" shadow-intensity="0.85" shadow-softness="1" camera-orbit="20deg 80deg auto" ar ar-modes="webxr scene-viewer quick-look" ar-scale="auto" loading="eager"><span slot="ar-button"></span></model-viewer>');
var mv = $("model-viewer", caja); mv.addEventListener("load", function () { var c = $("[data-yj-3d-cargando]", sec); if (c) c.hidden = true; mvAr = mv; arPintar(); setTimeout(arPintar, 1500); });
}
if (!hayIO || QA) { montar(); return; }
var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); montar(); } }, { rootMargin: "600px 0px" }); io.observe(sec);
}
function pintarDinamicos() {
Q("[data-yj-tono]").forEach(function (b) { atr(b, "aria-pressed", b.getAttribute("data-yj-tono") === u0().c ? "true" : "false"); });
}
var vistas = hayIO ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { vistas.unobserve(e.target); track("seccion_vista_" + e.target.getAttribute("data-yj-lote")); } }); }, { threshold: 0.25 }) : null;
function cada(sel, fn, base) { $$(sel, base).forEach(function (e) { if (e.__yjOk) return; e.__yjOk = 1; fn(e); }); }
function initLote(base) {
olvidar();
resolverFotos(base);
cada("[data-yj-carr]", initCarr, base);
cada("[data-yj-bus]", initBuscador, base);
cada("[data-yj-faq], [data-yj-acc]", initAcc, base);
cada("[data-yj-look]", initLook, base);
cada("[data-yj-3d]", init3d, base);
cada("[data-yj-loop]", initLoop, base);
cada("[data-yj-ver]", initVer, base);
cada(".yj-sec h2,.yj-sec h3,img.yj-st", initVer, base);
cada(".yj-cta[data-yj-comprar], .yj-cta[data-yj-finalizar]", initCta, base);
cada("#yj-resenas", initResenas, base);
$$("[data-yj-modelo]", base).forEach(function (e) { e.textContent = CFG.modeloTalla || "6"; });
$$("[data-yj-seguidores]", base).forEach(function (e) { if (CFG.seguidores) e.textContent = CFG.seguidores; });
pintarRatings(); pintarPrecios(); pintarDinamicos(); pintarTex();
}
var ranuras = $$("[data-yj-lote]"), descargas = {}, fallo = 0, arrancado = false, vigia = null;
YJ.lotesPedidos = [];
function traerLote(r) {
var n = r.getAttribute("data-yj-lote"), src = r.getAttribute("data-yj-lote-src");
if (r.hasAttribute("data-yj-si-glb") && !CFG.glb) return Promise.resolve(null);
if (!descargas[n] && Date.now() - fallo < 4000) return Promise.reject(new Error("reintento"));
if (!descargas[n]) { YJ.lotesPedidos.push(+n); descargas[n] = fetch(src).then(function (x) { if (!x.ok) throw new Error(x.status); return x.json(); }).then(function (j) {
var t = document.createElement("template");
t.innerHTML = String(j.html).replace(/(^|[\s"'(,])assets\/(?=yj-)/g, "$1" + BASE);
return t;
}).catch(function (e) { delete descargas[n]; fallo = Date.now(); throw e; }); }
return descargas[n];
}
var CV = !!(window.CSS && CSS.supports && CSS.supports("content-visibility", "auto"));
function marca(n) { try { performance.mark(n); } catch (e) {} }
function cssSecciones() { var s = document.getElementById("yj-css-secciones"); if (s && s.media !== "all") { s.media = "all"; marca("yj-css-secciones"); } }
YJ.cssSecciones = cssSecciones;
function altoReservado(r) { var h = String(r.getAttribute("data-yj-h") || "").split(","), v = +(innerWidth < 900 ? h[0] : h[1] || h[0]); return v > 120 ? v : 900; }
function montar(r, t) {
r.classList.add("is-lista");
if (!t) { r.parentNode.removeChild(r); return Promise.resolve(); }
cssSecciones();
resolverFotos(t.content);
if (CV) { r.style.containIntrinsicSize = "auto " + altoReservado(r) + "px"; r.classList.add("is-cv"); }
var id = r.getAttribute("data-yj-lote-id"); marca("yj-montar-" + id);
r.appendChild(t.content.cloneNode(true)); marca("yj-append-fin-" + id);
return new Promise(function (ok) { setTimeout(function () { marca("yj-init-" + id); initLote(r); if (vistas) vistas.observe(r); marca("yj-init-fin-" + id); ok(); }, 0); });
}
function insertarLote(r) {
if (!r || r.classList.contains("is-lista")) return Promise.resolve();
return traerLote(r).then(function (t) { if (vigia) vigia.unobserve(r); if (r.classList.contains("is-lista")) return; return new Promise(function (ok) { setTimeout(function () { ok(r.classList.contains("is-lista") ? null : montar(r, t)); }, 0); }); }, function (e) {
if (window.console && e.message !== "reintento") console.error("yj lote", e); });
}
function insertarHasta(id) {
var p = Promise.resolve();
for (var i = 0; i < ranuras.length; i++) { (function (r) { p = p.then(function () { return insertarLote(r); }); })(ranuras[i]); if (ranuras[i].getAttribute("data-yj-lote-id") === id) break; }
return p;
}
YJ.cargarTodo = function () { return insertarHasta(null); };
function unidadSinTalla() { for (var i = 0; i < est.unis.length; i++) if (!est.unis[i].t) return i; return 0; }
function irA(id) {
if (id === "tallas") { abrirGuia(); return; }
insertarHasta(id).then(function () {
var el = document.getElementById("yj-" + id); if (!el) return;
requestAnimationFrame(function () { el.scrollIntoView({ behavior: comp, block: "start" }); });
[900, 1800].forEach(function (ms) { setTimeout(function () { if (Math.abs(el.getBoundingClientRect().top) > 40) el.scrollIntoView({ block: "start" }); }, ms); });
});
}
function revisarLotes() {
if (ocupado) return;
var r = ranuras.filter(function (x) { return !x.classList.contains("is-lista"); })[0];
if (!r) { if (vigia) vigia.disconnect(); document.removeEventListener("scroll", revisarScroll, true); return; }
var falta = r.getBoundingClientRect().top - innerHeight;
if (falta < 2500) traerLote(r).catch(function () {});
if (falta < 1200) { ocupado = true; insertarLote(r).then(function () { ocupado = false; requestAnimationFrame(revisarLotes); }); }
}
var ocupado = false, revisarScroll = porFrame(revisarLotes);
function arrancarLotes() {
if (arrancado) return; arrancado = true;
if (hayIO) { vigia = new IntersectionObserver(revisarScroll, { rootMargin: "0px 0px 2500px 0px" }); ranuras.forEach(function (r) { vigia.observe(r); }); }
alScroll(revisarScroll);
revisarLotes();
}
function roving(g) {
if (!g) return;
var rs = $$('[role="radio"]', g).filter(function (r) { return !r.disabled && r.getAttribute("aria-disabled") !== "true"; }), c = rs.filter(function (r) { return r.getAttribute("aria-checked") === "true"; })[0] || rs[0];
$$('[role="radio"]', g).forEach(function (r) { var v = r === c ? 0 : -1; if (r.tabIndex !== v || !r.hasAttribute("tabindex")) r.tabIndex = v; });
}
function rovingTodo() { $$('[role="radiogroup"]').forEach(roving); }
function selDe(el) { if (!el || !el.getAttribute) return null; var a = ["data-yj-u", "data-yj-uc", "data-yj-ut", "data-yj-color", "data-yj-talla", "data-yj-n", "data-yj-ciu", "data-yj-regt-t", "data-yj-hn"], s = ""; a.forEach(function (k) { var v = el.getAttribute(k); if (v != null) s += "[" + k + '="' + String(v).replace(/"/g, '\\"') + '"]'; }); return s || null; }
function conFoco(fn) {
var f = document.activeElement, s = raiz.contains(f) ? selDe(f) : null, cont = f && f.closest ? f.closest("dialog") || raiz : raiz; fn();
if (s && !raiz.contains(f)) { var n = $(s, cont); if (n) try { n.focus({ preventScroll: true }); } catch (e) { n.focus(); } }
}
raiz.addEventListener("keydown", function (e) {
var t = e.target;
if (t.getAttribute && t.getAttribute("role") === "button" && t.tagName !== "BUTTON" && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); t.click(); return; }
if (!t.getAttribute || t.getAttribute("role") !== "radio") return;
var d = e.key === "ArrowRight" || e.key === "ArrowDown" ? 1 : e.key === "ArrowLeft" || e.key === "ArrowUp" ? -1 : 0; if (!d) return;
var g = t.closest('[role="radiogroup"]'); if (!g) return;
var rs = $$('[role="radio"]', g).filter(function (r) { return !r.disabled && r.getAttribute("aria-disabled") !== "true"; }), i = rs.indexOf(t); if (i < 0) return;
e.preventDefault();
var sig = rs[(i + d + rs.length) % rs.length], s = selDe(sig), cont = g.closest("dialog") || raiz;
sig.click();
var n = raiz.contains(sig) ? sig : (s && $(s, cont)) || sig; try { n.focus({ preventScroll: false }); } catch (x) { n.focus(); }
});
raiz.addEventListener("click", function (e) { var r; conFoco(function () { r = alClic(e); }); return r; });
var sinAccion = {}, sinAccionN = 0;
function alClic(e) {
var t = e.target.closest ? e.target : e.target.parentNode, x;
if (dlg && dlg.open && (x = t.closest('[data-yj-dlg] [role="radio"]'))) { var fl = x.closest(".is-falta"); if (fl) fl.classList.remove("is-falta"); var ek = ++errTok; luego("err", function () { if (ek !== errTok) return; var er = $("[data-yj-dlg-err]", dlg); if (er && er.firstChild) er.textContent = ""; }); }
if ((x = t.closest("[data-yj-tallas] [data-yj-talla]"))) { if (x.getAttribute("aria-disabled") !== "true") elegirTalla(x.getAttribute("data-yj-talla"), 0, true, "pagina"); return; }
if ((x = t.closest("[data-yj-colores] [data-yj-color]"))) { elegirColor(x.getAttribute("data-yj-color"), 0, true); if (!reducido && !tieneHover) { $$(".yj-color.is-lupa", boxColores).forEach(function (b) { if (b !== x) b.classList.remove("is-lupa"); }); reanimar(x, "is-lupa"); } return; }
if ((x = t.closest("[data-yj-hn]"))) { elegirPaquete(+x.getAttribute("data-yj-hn"), null, true); return; }
if ((x = t.closest("[data-yj-gt-b]"))) { var gt = x.closest("[data-yj-gt]"), ve = !gt.classList.contains("is-on"); gt.classList.toggle("is-on", ve); if (ve) track("popup_guia_vista"); luego("gt", function () { atr(x, "aria-expanded", ve ? "true" : "false"); if (ve) try { gt.scrollIntoView({ behavior: comp, block: "nearest" }); } catch (e2) {} }); return; }
if ((x = t.closest("[data-yj-barra-comprar]"))) { comprarBarra(x); return; }
if ((x = t.closest(".yj-regalo"))) { var kr = +x.getAttribute("data-desde"); if (kr > est.n) { track("regalo_toque"); elegirPaquete(kr, $('[data-yj-n="' + kr + '"]', boxPaq)); } return; }
if ((x = t.closest("[data-yj-uc]"))) { elegirColor(x.getAttribute("data-yj-uc"), +x.getAttribute("data-yj-u"), true, "popup"); return; }
if ((x = t.closest("[data-yj-ut]"))) { if (x.getAttribute("aria-disabled") !== "true") elegirTalla(x.getAttribute("data-yj-ut"), +x.getAttribute("data-yj-u"), true, "popup"); return; }
if ((x = t.closest("[data-yj-xt-v]"))) { if (xt) { var idx = x.getAttribute("data-yj-xt-v"); xt.v = xt.vs.filter(function (v) { return String(v.id) === idx; })[0] || xt.v; track("top_color"); pintarXt(); luego("xt", function () { pintarPrecios(); rovingTodo(); }); } return; }
if ((x = t.closest("[data-yj-regt-t]"))) { est.regaloTalla = x.getAttribute("data-yj-regt-t"); if (regt) marcarRadios(regt.el, "data-yj-regt-t", est.regaloTalla); luego("regt", function () { pintarRegaloTalla(); rovingTodo(); }); track("popup_talla_regalo"); return; }
if ((x = t.closest("[data-yj-ciu]"))) { elegirCiudad(x.getAttribute("data-yj-ciu"), true); if (x.closest("[data-yj-dlg]")) track("popup_ciudad"); return; }
if ((x = t.closest("[data-yj-ciu-cambiar]"))) { abrirCambiar(x, x.getAttribute("aria-expanded") !== "true"); return; }
if ((x = t.closest("[data-yj-paq] [data-yj-n]"))) { elegirPaquete(+x.getAttribute("data-yj-n"), x); return; }
if ((x = t.closest("[data-yj-sube]"))) { var ks = +x.getAttribute("data-yj-sube"); track("empuje_cantidad_" + ks); elegirPaquete(ks, $('[data-yj-n="' + ks + '"]', boxPaq)); return; }
if ((x = t.closest("[data-yj-finalizar-ant]"))) { alFinalizarDlg(x, true); return; }
if ((x = t.closest("[data-yj-comprar-ant]"))) { comprar(x, false, true); return; }
if ((x = t.closest("[data-yj-finalizar]"))) { alFinalizarDlg(x); return; }
if ((x = t.closest("[data-yj-dlg-cerrar]"))) { cerrarRapido(); return; }
if ((x = t.closest("[data-yj-comprar]"))) { comprar(x, !x.closest(".yj-accion")); return; }
if ((x = t.closest("[data-yj-carrito]"))) { abrirCarrito(); return; }
if ((x = t.closest("[data-yj-tono]"))) { elegirColor(x.getAttribute("data-yj-tono"), 0, true); return; }
if ((x = t.closest(".yj-vid"))) { reproducir(x); return; }
if ((x = t.closest("[aria-controls][aria-expanded]")) && (x.closest("[data-yj-acc]") || x.closest("[data-yj-faq]"))) { var abre = x.getAttribute("aria-expanded") !== "true"; abrirAcc(x, abre); if (abre) { track(x.closest("[data-yj-faq]") ? "faq_abierta" : "detalle_abierto"); if (x.getAttribute("data-yj-acc-ev")) track(x.getAttribute("data-yj-acc-ev")); } return; }
if ((x = t.closest("a[data-yj-pol]"))) { e.preventDefault(); abrirPolitica(x); return; }
if ((x = t.closest('a[href="#yj-tallas"]'))) { e.preventDefault(); var gx = x, gu = dlg && dlg.open && dlg.contains(x) ? unidadSinTalla() : null; abrirTras(gx, function () { abrirGuia(gx, gu); }); return; }
if ((x = t.closest('a[href^="#yj-"]'))) { e.preventDefault(); irA(x.getAttribute("href").slice(4)); return; }
if ((x = t.closest("[data-yj-gal-pista] .yj-gal__slide"))) { track("foto_toque"); irGal(galAct + 1, true); return; }
if ((x = t.closest("[data-yj-abre]"))) { abrirDetalle(x.getAttribute("data-yj-abre")); return; }
if ((x = t.closest("[data-yj-ir]"))) { irA(x.getAttribute("data-yj-ir")); return; }
if ((x = t.closest(".yj-compra [data-yj-pgs]"))) { track("logos_pago_toque"); abrirDetalle("envios"); return; }
if (t.closest(".yj-compra") && !t.closest("button,a,[role=button],[role=radio],input,select,textarea,label,summary,[data-yj-gal-pista],dialog")) {
var pz = t.closest("[class]"), nom = pz ? "." + String(pz.className && pz.className.baseVal != null ? pz.className.baseVal : pz.className).trim().split(/\s+/)[0] : t.tagName.toLowerCase();
if (!sinAccion[nom] && sinAccionN < 6) { sinAccion[nom] = 1; sinAccionN++; track("toque_sin_accion"); marcarDato("toque_sin_accion", nom); YJ.sinAccion = Object.keys(sinAccion); }
}
}
function abrirDetalle(id) {
var b = document.getElementById("yj-accb-" + id); if (!b) return;
if (b.getAttribute("aria-expanded") !== "true") { abrirAcc(b, true); track("detalle_abierto"); }
requestAnimationFrame(function () { b.scrollIntoView({ behavior: comp, block: "center" }); });
}
raiz.classList.add("yj-js");
function ligero(motivo) { if (YJ.ligero) return; YJ.ligero = motivo; raiz.classList.add("yj-ligero"); track("modo_ligero"); marcarDato("ligero", motivo); }
YJ.modoLigero = ligero;
if ((navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2) || (navigator.deviceMemory && navigator.deviceMemory <= 2)) ligero("equipo");
else try {
var poLento = new PerformanceObserver(function (l) { l.getEntries().some(function (e) { if (e.interactionId && e.duration >= 200) { poLento.disconnect(); ligero("toque_lento"); return true; } return false; }); });
poLento.observe({ type: "event", durationThreshold: 104 });
} catch (e) {}
if (hayIO) { var ojoAnim = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle("is-quieta", !e.isIntersecting); }); }); $$(".yj-compra, .yj-anuncio").forEach(function (e) { ojoAnim.observe(e); }); }
var armar = function () { raiz.removeEventListener("pointerdown", armar, true); ocio(crearDlg); };
raiz.addEventListener("pointerdown", armar, { capture: true, passive: true });
var armarTrasLoad = function () { ocio(cssSecciones); setTimeout(function () { ocio(crearDlg); }, 1500); };
if (document.readyState === "complete") armarTrasLoad(); else window.addEventListener("load", armarTrasLoad);
saludar();
cada("[data-yj-ver]", initVer);
cada("[data-yj-acc]", initAcc);
cada(".yj-cta[data-yj-comprar]", initCta);
ajustarUnis();
pintarSeleccion();
pintarRatings();
pintarCarrito();
var ciuGuardada = leerSes("yj-ciu"); if (ciuGuardada && CIUS[ciuGuardada]) { elegirCiudad(ciuGuardada, false); ciuManual = true; } else sinCiudad(false);
pintarEntrega();
initReloj();
initBarra();
var hashYj = /^#yj-([\w-]+)/.exec(location.hash);
if (hashYj && hashYj[1] === "tallas") { hashYj = null; abrirGuia(); }
if (QA || !window.fetch) { arrancado = true; YJ.cargarTodo(); }
else if (hashYj) { arrancado = true; irA(hashYj[1]); }
else {
var una = function () { ["scroll", "wheel", "touchmove", "keydown"].forEach(function (ev) { document.removeEventListener(ev, una, true); }); arrancarLotes(); };
["scroll", "wheel", "touchmove", "keydown"].forEach(function (ev) { document.addEventListener(ev, una, { passive: true, capture: true }); });
}
window.addEventListener("hashchange", function () { var h = /^#yj-([\w-]+)/.exec(location.hash); if (h) { if (h[1] === "tallas") { abrirGuia(); return; } arrancado = true; irA(h[1]); } });
if (document.readyState === "complete") detectarCiudad(); else window.addEventListener("load", detectarCiudad);
if (!QA && !LOCAL) popAutoArrancar();
})();